(function () {
    var _lodash = window._;
    var _ = {
        ready: false,//document.ready
        containerTypes: ["DIV", "TABLE", "FORM", "BODY", "HTML", "NAV", "FIELDSET", "TR", "TD"],//容器类型标签
        cacheSpace: {},//缓存用存储
        fakeFocus: $("#fakeFocus"),//转移焦点用

        region: {//业务块用
            space: {},//分块存储
            defaults: {
                original: {
                    list: {
                        //请求信息
                        request: {
                            type: "post",
                            data: function () {
                                return {
                                    _limit: 15//单页数量
                                };
                            },
                            dataType: "json",
                        },
                        emptyTemplate: null,//无数据时模板
                        //分页配置
                        pagination: {
                            enabled: true,//是否显示分页
                            mini: false,//是否为精简模式（只包含页码选择部分，只对默认模板有效，自定义模板时需要自行实现@root.mini）,
                            template: null,//分页模板，传入时替代默认模板
                            markers: 8//最大显示页码数量
                        },
                        //多选配置
                        multiSelect: {
                            enabled: false,//是否支持多选
                            keep: false,//是否跨页选择
                            template: null,//批量操作按钮模板，传入时替代默认模板
                            templateData: {},//模板数据
                            freeze: false//是否被冻结（未被冻结时请勿启用本选项）
                        },
                        //冻结设置
                        freeze: {
                            enabled: false,//是否冻结列
                            left: {
                                column: 0,//列数
                                className: "region-freeze-column"//标记类
                            },
                            right: {
                                column: 0,
                                className: "region-freeze-column"
                            },
                            specificClassState: {//特殊标记类
                                hover: "hover"//在hover时，通过mouseover mouseout模拟
                            },
                            event: {//特殊事件
                                mouseOver: null,//鼠标进入，模拟hover
                                mouseOut: null,//鼠标移出，模拟hover
                                render: null,//冻结部分渲染完成
                            }
                        }
                    },
                    onSortChange: null//当排序状态被切换时（clearSort时不会触发）
                },
                zuiDataGrid: {
                    dataSource: {
                        cache: false
                    },
                    height: "page",
                    sortable: true,
                    selectable: {
                        trigger: ".datagrid-row-cell .selectable,.datagrid-row-cell .datagrid-has-checkbox"
                    },
                    states: {
                        pager: {
                            page: 1,
                            recPerPage: 15,
                        }
                    },
                    _multiSelect: {
                        template: null,//批量操作按钮模板，传入时替代默认模板
                        templateData: {}//模板数据
                    },
                    _pager: {//分页器配置
                        page: 1,
                        recPerPage: 10,
                        elements: ['items_range_text', 'total_text', 'first', 'prev', 'pages', 'next', 'last'],
                        maxNavCount: 8,
                        lang: {
                            prev: "上一页",
                            next: "下一页",
                            first: "首页",
                            last: "末页",
                            goto: "跳转",
                            pageOf: "第 {page} 页",
                            totalPage: "共 {totalPage} 页",
                            totalCount: "总共 {recTotal} 条记录",
                            pageSize: "每页 {recPerPage} 项",
                            itemsRange: "显示第 {start} 到第 {end} 条记录",
                            pageOfTotal: "第 {page}/{totalPage} 页"
                        },
                        pageSizeOptions: [15, 20, 30, 50]
                    }
                }
            },
            sort: [
                {
                    _step: "none",
                    css: "icon-sort-amount-down list-sortable-deactive"
                },
                {
                    _step: "desc",
                    css: "icon-sort-amount-down list-sortable-active"
                },
                {
                    _step: "asc",
                    css: "icon-sort-amount-up list-sortable-active"
                }
            ]
        },
        loading: {//加载指示器
            element: $("#page-loading"),
            timeout: 300,
            counter: 0,
            timer: undefined
        },
        loadingToast: {//加载指示器
            element: $("#page-loading-toast"),
            timeout: 300,
            counter: 0,
            timer: undefined
        },
        waiting: {//等待指示器
            timeout: 300,
            counter: 0,
            timer: undefined,
            layerIndex: undefined
        },
        collect: {//数据收集用
            defaults: {
                force: false,//强制收集所有表单元素（覆盖data-ignore）
                collect: "____auto"//收集方式（_.collect.collectTypes或自定义属性）
            },
            collectTypes: {//收集方式
                auto: "____auto",//自动收集（使用元素的data-collectSubmit属性）
                submit: "____submit",//收集元素上的submit数据（data-submit）
                val: "____val"//收集元素的val值
            },
            ignoreInputTypes: ["button", "image", "reset"]//忽略input的类型
        },
        fill: {//数据填充用
            matchRegex: /\[.+?]/i,
            defaults: {
                force: false,//强制填充所有表单元素（覆盖data-ignore）
                handler: null//自定义值处理
            },
            ignoreInputTypes: ["button", "image", "reset"]//忽略input的类型
        },
        select2Cascade: {},//select级联用
        dialog: {//对话框编辑状态对比
            opened: {},//当前打开的对话框（key=domID）
            compare: {}//对话框对比值（key=domID）
        },
        multiLevelDropdown: {//多级下拉菜单用
            id: 0,//下标
            storage: {}//存储
        }
    };
    var shortcut = {
        /**
         * 生成错误的Promise
         * @param reason
         * @returns {*}
         */
        generateReject: function (reason) {
            return new Promise(function (res, rej) {
                rej(reason);
            });
        },

        /**
         * 步进
         * @param array 来源数组
         * @param value 当前值（与_step字段做对比）
         * @param go 方向（向前：-1，向后：1）
         * @returns {*}
         */
        step: function (array, value, go) {
            if (go === 0)
                return;

            var itemIndex = -1;
            $.each(array, function (index, item) {
                if (item._step === value) {
                    itemIndex = index;
                    return false;
                }
            });

            if (itemIndex < 0)
                return;

            if (go > 0) {
                return {
                    current: array[itemIndex],
                    next: array[(itemIndex + 1) >= array.length ? 0 : (itemIndex + 1)]
                };
            } else if (go < 0) {
                return {
                    current: array[itemIndex],
                    next: array[(itemIndex - 1) < 0 ? (array.length - 1) : (itemIndex - 1)]
                };
            }
        },

        /**
         * 替换变量
         * @param storage 旧值存储
         * @param source 来源
         * @param path 字段路径
         * @param value 新值
         */
        port: function (storage, source, path, value) {
            storage[path] = objectPath.get(source, path);
            objectPath.set(source, path, value);
        },

        /**
         * 获取业务块配置
         * @param regionName 业务块
         * @private
         */
        _getRegion: function (regionName) {
            var displayName = regionName || "默认业务块";
            var region = _.region.space[regionName];
            if (!region) {
                bridge.warn("找不到业务块 \'" + displayName + "\'");
                return {};
            }

            if (!region.storage) {
                bridge.warn("\'" + displayName + "\' 是一个无效的业务块，请检查该业务块的storage是否被错误的修改");
                return {};
            }

            if (!region.storage._isInitialized) {
                bridge.warn("请先对 \'" + displayName + "\' 进行初始化再尝试调用");
                return {};
            }

            return region;
        },

        /**
         * 空返回
         * @private
         */
        _emptyMethod: function () {
            return null;
        },

        /**
         * 多选响应
         * @private
         */
        _multiSelectHandler: function (e) {
            var st = shortcut._getRegion(e.handleObj.data.region).storage;
            var storage = st._multiSelect;
            var input = $(e.target);
            var data = input.data();
            var checked = input.prop("checked");
            var row = input.parents("tr");
            var scope = (st.cfg.list.multiSelect.freeze ? ".region-list.region-freeze-table" : ".region-list");

            if (input.parent().hasClass("list-multiSelect-root")) {
                var childs = st.selector.find(scope + " .list-multiSelect input:not([disabled])");
                if (childs.length > 0) {
                    childs.prop("checked", checked).trigger("change");
                    if (st._zuiSelectable) {
                        st._zuiSelectable.data("zui.selectable")[checked ? "select" : "unselect"]();
                    }
                } else {
                    input.prop("checked", false);//在无列表项时点击后恢复成未选中
                }
                return;
            }

            var existsIndex = -1;//查找是否存在
            $.each(storage, function (index, item) {
                if (item.id === data.selectid) {
                    existsIndex = index;
                    return false;
                }
            });

            if (checked && existsIndex === -1) {//勾选
                storage.push({
                    id: data.selectid,
                    data: data.selectdata || {}
                });
            } else if (!checked && existsIndex > -1) {//取消勾选
                storage.splice(existsIndex, 1);
            }

            if (st.cfg.list.multiSelect.freeze)
                st.selector.find(".region-list tbody").find("tr:eq(" + row.index() + ")")[(checked ? "add" : "remove") + "Class"]("selected");
            else
                row[(checked ? "add" : "remove") + "Class"]("selected");

            var checkboxItems = st.selector.find(scope + " .list-multiSelect input:not([disabled])");
            st.selector.find(scope + " .list-multiSelect-root input").prop("checked", checkboxItems.length === $.grep(checkboxItems, function (item) {
                return item.checked;
            }).length);
        },

        /**
         * 对zui selectable用屏蔽直接点击用响应
         * @private
         */
        _multiSelectZuiSelectableSupportHandler: function (e) {
            var st = shortcut._getRegion(e.handleObj.data.region).storage;
            if (st._zuiSelectable) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }
        },

        /**
         * 对zui datagrid的多选组件修复存储错误问题
         */
        _multiSelectZuiDataGridStorageFix: function (region, data, checked) {
            if (!region.storage._multiSelect)
                region.storage._multiSelect = [];
            var storage = region.storage._multiSelect;

            var existsIndex = -1;//查找是否存在
            $.each(storage, function (index, item) {
                if (item.id === data.id) {
                    existsIndex = index;
                    return false;
                }
            });

            if (checked && existsIndex === -1)
                storage.push($.extend(true, {}, data));
            else if (!checked && existsIndex !== -1)
                storage.splice(existsIndex, 1);
        },

        /**
         * 排序响应
         * @private
         */
        _sortHandler: function (e) {
            var regionName = e.handleObj.data.region;
            var st = shortcut._getRegion(regionName).storage;
            var storage = st._sort;
            var column = $(this);
            var data = column.data();

            var itemIndex = -1;
            $.each(storage, function (index, item) {
                if (item.dataKey === data.key) {
                    itemIndex = index;
                    return false;
                }
            });

            if (data.single === true && itemIndex === -1) {
                storage = [];
                st._sort = storage;
                st.selector.find(".list-sortable .list-sortable-icon")
                    .removeClass(
                        _.region.sort.slice(1).map(function (item) {
                            return item.css;
                        }).join(" ")
                    )
                    .addClass(_.region.sort[0].css);
            }

            var step = null;
            if (itemIndex < 0) {
                step = shortcut.step(_.region.sort, _.region.sort[0]._step, 1);
                storage.push({
                    dataKey: data.key,
                    status: step.next._step,
                    css: step.next.css
                });
            } else {
                step = shortcut.step(_.region.sort, storage[itemIndex].status, 1);

                if (step.next._step === "none")
                    storage.splice(itemIndex, 1);
                else {
                    storage[itemIndex].status = step.next._step;
                    storage[itemIndex].css = step.next.css;
                }
            }
            st.selector.find(".list-sortable[data-key='" + data.key + "'] .list-sortable-icon")
                .removeClass(step.current.css)
                .addClass(step.next.css);

            if (st.cfg.onSortChange)
                st.cfg.onSortChange({
                    key: data.key,
                    status: step.next._step,
                    css: step.next.css
                });
            else
                region(regionName).list();//更新列表
        },

        /**
         * 收集数据
         * @returns {*}
         * @private
         */
        _collectValue: function (collectType, selector, data, value) {
            switch (collectType) {
                case _.collect.collectTypes.auto:
                    return (data.collectsubmit ? data.submit : null) || (value !== undefined ? value : selector.val());
                case _.collect.collectTypes.submit:
                    return data.submit || (value !== undefined ? value : selector.val());
                case _.collect.collectTypes.val:
                    return value !== undefined ? value : selector.val();
                default:
                    return selector.attr(collectType);
            }
        },

        /**
         * select2 级联控制器
         * @private
         */
        _select2CascadeController: function (e) {
            var configurations = e.handleObj.data;
            var self = $(this);
            var select2 = self.data("select2");

            if (select2) {
                var data = common.collect(self);//获取数据
                if (configurations.handler)
                    data = configurations.handler(self, data) || data;//处理数据

                $.each(_.select2Cascade[configurations.key], function (index, child) {
                    var storageObj = child.selector.data("cascadeData");//在cascadeData中存储数据
                    if (!storageObj)
                        storageObj = {};
                    storageObj[child.alias !== undefined ? child.alias : configurations.key] = data;
                    child.selector.data("cascadeData", storageObj);

                    if (child.handler)//触发子级响应
                        child.handler(self, data, child.selector);
                });
            }
        },

        /**
         * select2 值强制更新
         * @private
         */
        _select2ForceUpdateHandler: function (e) {
            var selected = e.params.args.data;
            $(this).find("option").each(function (index, item) {
                if (item.value === selected.id.toString()) {
                    $(item).remove();
                    return false;
                }
            });
        },

        /**
         * 多级下拉菜单 更新位置
         * @param dom 多级下拉菜单jQuery对象
         * @param relative 相对元素jQuery对象
         * @param offset 偏移值
         * @private
         */
        _multiLevelDropdownReposition: function (dom, relative, offset) {
            if (!dom || !relative)
                return;

            var pos = relative.offset();
            dom.css({
                top: (pos.top + relative.height() + (offset ? (offset.y || 0) : 0) + 10) + "px",
                left: pos.left + (offset ? (offset.x || 0) : 0) + "px"
            });
        },

        /**
         * 多级下拉菜单 默认搜索处理
         * @param data 多级数据源
         * @param keyword 关键字
         * @private
         */
        _multiLevelDropdownSearchHandler: function (data, keyword) {
            if (data.length === 0)
                return;

            return data[0].filter(function (item) {
                return item.text.indexOf(keyword) > -1;
            });
        },

        /**
         * 多级下拉菜单 失去焦点处理
         * @private
         */
        _multiLevelDropdownBlurHandler: function (e) {
            setTimeout(function () {
                var id = e.handleObj.data.id;

                var dropdown = $("#dropdown-multi-container-" + id);
                dropdown.off("click mouseenter")
                dropdown.remove();

                _lodash.set(_.multiLevelDropdown.storage, id + ".temp.latestRemoteLoading", false);
            }, 10);
        },

        /**
         * 多级下拉菜单 获得焦点/输入字符处理
         * @private
         */
        _multiLevelDropdownInitHandler: function (e) {
            var self = $(this);
            var value = self.val();
            var id = e.handleObj.data.id;
            var storage = _.multiLevelDropdown.storage[id];

            if (!storage)
                return;

            var initDropdown = function () {
                dropdown = $("#dropdown-multi-container-" + id);
                if (dropdown.length)
                    return dropdown;

                dropdown = $(templates.multiLevelDropdownContainer({
                    id: id,
                    customClass: storage.customClass
                }));
                $(document.body).append(dropdown);
                dropdown.on("mousedown", ".dropdown-level>li:not(.dropdown-item-placeholder)", {id: id}, shortcut._multiLevelDropdownChildClickHandler);
                dropdown.on("mouseenter", ".dropdown-level>li.hasChild", {id: id}, shortcut._multiLevelDropdownChildHoverHandler);

                return dropdown;
            };
            var dropdown = initDropdown();

            var workflow = Promise.resolve(_lodash.get(storage, "temp.latestRemoteWorkflowStorage") || {});
            var isLatestRemoteLoading = _lodash.get(storage, "temp.latestRemoteLoading");
            if (storage.remote) {
                if (!isLatestRemoteLoading) {
                    _lodash.set(storage, "temp.latestRemoteLoading", true);

                    initDropdown();
                    dropdown.addClass("dropdown-multi-loading").html(templates.multiLevelDropdownLoading());
                    shortcut._multiLevelDropdownReposition(dropdown, self, storage.offset);
                }

                workflow = workflow
                    .then(storage.remote(value, storage.temp, e))
                    .then(function (workflowStorage) {
                        return new Promise(function (resolve, reject) {
                            var fn = _lodash.get(storage, "temp.latestRemoteLoading") ? resolve : reject;
                            storage.levels = workflowStorage.levels;

                            dropdown.removeClass("dropdown-multi-loading");
                            _lodash.set(storage, "temp.latestRemoteLoading", false);
                            _lodash.get(storage, "temp.latestRemoteWorkflowStorage", workflowStorage);
                            fn(workflowStorage);
                        });
                    });
            }

            workflow = workflow.then(function (workflowStorage) {
                return new Promise(function (resolve, reject) {
                    if (!storage.levels || storage.levels.length === 0) {
                        reject();
                        return;
                    }

                    var items = (workflowStorage.skipSearch ? null : (storage.search ? storage.search(storage.levels, value) : shortcut._multiLevelDropdownSearchHandler(storage.levels, value))) || storage.levels[0] || [];

                    initDropdown();
                    if (e.type === "input") {
                        self.data("submit", value);
                    }

                    dropdown.html(templates.multiLevelDropdownLevel({
                        isRoot: true,
                        items: items,
                        histories: self.multiLevelDropdownHistory() || [],
                        level: 0
                    }));
                    shortcut._multiLevelDropdownReposition(dropdown, self, storage.offset);
                })
            }, _lodash.noop).catch(_lodash.noop);
        },

        /**
         * 多级下拉菜单 点击元素处理
         * @private
         */
        _multiLevelDropdownChildClickHandler: function (e) {
            var self = $(this);
            var id = e.handleObj.data.id;
            var storage = _.multiLevelDropdown.storage[id];

            if (!storage || !storage.levels || storage.levels.length === 0 || self.hasClass("dropdown-item-disabled"))
                return;

            var val = self.data("val");
            var itemID = self.data("id");
            var found = $.map(storage.levels, function (level) {
                return level.filter(function (item) {
                    return item.id === itemID
                });
            });
            if (found.length > 0) {
                var text = (val !== null && val !== undefined) ? val : found[0].text;
                storage.source.val(text).data("submit", found[0].submit || text).trigger("change");

                if (storage.history.maximum > 0) {
                    var local = $.zui.store.get(storage.history.storage) || [];

                    if (_lodash.findIndex(local, function (find) {
                        return find.id === found[0].id
                    }) === -1)
                        local.unshift(found[0]);
                    if (local.length > 3)
                        local.splice(3);

                    $.zui.store.set(storage.history.storage, local);
                }
            }
        },

        /**
         * 多级下拉菜单 元素悬停展开处理
         * @private
         */
        _multiLevelDropdownChildHoverHandler: function (e) {
            var self = $(this);
            var id = e.handleObj.data.id;
            var itemID = self.data("id");
            var storage = _.multiLevelDropdown.storage[id];
            var dropdown = $("#dropdown-multi-container-" + id);

            if (!storage || !storage.levels || storage.levels.length === 0)
                return;

            var itemLevel = self.data("level");
            var parentLevel = self.parent().data("level");
            dropdown.find(".dropdown-level").each(function (index, item) {
                var obj = $(item);

                if (obj.data("level") > parentLevel)
                    obj.remove();
            });

            var items = storage.levels[itemLevel + 1];
            if (!items)
                return;
            items = items.filter(function (item) {
                return item.parent === itemID;
            });
            if (items.length === 0)
                return;
            dropdown.append(templates.multiLevelDropdownLevel({
                isRoot: false,
                items: items,
                level: itemLevel + 1
            }));

            self.addClass("active").siblings().removeClass("active");
        }
    };
    var templates = {
        listEmpty: utils.template(
            '<tr>' +
            '    <td class="text-center" colspan="{{default cols 1}}">{{default text "暂无数据"}}</td>' +
            '</tr>'
        ),
        listPagination: utils.template(
            // '{{log this}}' + //DEBUG
            '{{#if enabled}}' +
            '    {{#if mini}}{{else}}' +
            '        <span class="page-table-pagination-info">显示第 {{info.start}} 到第 {{info.to}} 条记录，总共 {{info.count}} 条记录</span>' +
            '    {{/if}}' +
            '    <ul class="pager pull-right">' +
            '        <li class="previous{{#compare info.page \'<\' 2}} disabled{{/compare}}">' +
            '            <a href="javascript:" onclick="region({{#if regionName}}\'{{regionName}}\'{{/if}}).list(1)">{{#if mini}}<<{{else}}首页{{/if}}</a>' +
            '        </li>' +
            '        <li{{#compare info.page "<" 2}} class="disabled"{{/compare}}>' +
            '            <a href="javascript:" onclick="region({{#if regionName}}\'{{regionName}}\'{{/if}}).list({{#compare info.page \'===\' 1}}1{{else}}{{math info.page \'-\' 1}}{{/compare}})">上一页</a>' +
            '        </li>' +

            '        {{#compare info.links ">" (math info.page "+" 2)}}' +
            '            {{set "_to" (math info.page "+" 2)}}' +
            '        {{else}}' +
            '            {{set "_to" info.links}}' +
            '        {{/compare}}' +

            '        {{#compare (math _to "-" info.markers) "<" 1}}' +
            '            {{set "_start" 1}}' +
            '        {{else}}' +
            '            {{set "_start" (math _to "-" info.markers)}}' +
            '            {{set "_start" (math _start "+" 1)}}' +
            '        {{/compare}}' +

            '        {{set "_temp" (math _to "-" _start)}}' +
            '        {{#compare _temp "<" info.markers}}' +
            '            {{#compare info.markers "<" info.links}}' +
            '                {{set "_temp" (math info.markers "-" _temp)}}' +
            '                {{set "_to" (math _to "+" _temp)}}' +
            '                {{set "_to" (math _to "-" 1)}}' +
            '            {{else}}' +
            '                {{set "_to" info.links}}' +
            '            {{/compare}}' +
            '        {{/compare}}' +

            '        {{#for _start (math _to "+" 1) 1}}' +
            '            <li{{#compare @index "===" @root.info.page}} class="active"{{/compare}}>' +
            '                <a href="javascript:" onclick="region({{#if @root.regionName}}\'{{@root.regionName}}\'{{/if}}).list({{@index}})">{{@index}}</a>' +
            '            </li>' +
            '        {{/for}}' +

            '        <li{{#compare info.page "===" info.links}} class="disabled"{{/compare}}>' +
            '            <a href="javascript:" onclick="region({{#if regionName}}\'{{regionName}}\'{{/if}}).list({{#compare info.page \'===\' info.links}}info.links{{else}}{{math info.page \'+\' 1}}{{/compare}})">下一页</a>' +
            '        </li>' +
            '        <li class="next{{#compare info.page \'===\' info.links}} disabled{{/compare}}">' +
            '            <a href="javascript:" onclick="region({{#if regionName}}\'{{regionName}}\'{{/if}}).list({{info.links}})">{{#if mini}}>>{{else}}末页{{/if}}</a>' +
            '        </li>' +
            '    </ul>' +
            '{{/if}}'
        ),
        listMultiSelectButton: utils.template(
            '{{#compare items.length ">" 0}}' +
            '<div class="dropdown dropdown-hover dropup">' +
            '    <button class="btn" type="button">{{default text "批量操作"}}' +
            '        <span class="caret"></span>' +
            '    </button>' +
            '    <ul class="dropdown-menu">' +
            '        {{#each items}}' +
            '        <li class="{{#if permits.require}}require-permits{{/if}}"{{#if permits.require}} data-permitsUrl="{{permits.url}}" data-permitsFail="{{permits.fail}}"{{/if}}>' +
            '            <a href="javascript:" onclick="{{callback}}">{{text}}</a>' +
            '        </li>' +
            '        {{/each}}' +
            '    </ul>' +
            '</div>' +
            '{{/compare}}'
        ),
        multiLevelDropdownContainer: utils.template(
            '<div class="dropdown-multi{{#if customClass}} {{customClass}}{{/if}}" id="dropdown-multi-container-{{id}}"></div>'
        ),
        multiLevelDropdownLevel: utils.template(
            '<ul class="dropdown-level{{#if isRoot}} dropdown-root{{/if}}{{#if (? items.length \'===\' 0)}} dropdown-empty{{/if}}" data-level="{{level}}">' +
            '{{#if (? histories.length ">" 0)}}' +
            '    {{#each histories}}' +
            '    <li class="{{#if hasChild}}hasChild{{/if}}{{#if disabled}} dropdown-item-disabled{{/if}}" data-id="{{id}}" data-val="{{#if val}}{{val}}{{else}}{{text}}{{/if}}" data-level="{{#if level}}{{level}}{{else}}{{@root.level}}{{/if}}">' +
            '        <div title="{{val}}">{{{val}}}</div>' +
            '        <div title="{{description}}">{{{description}}}</div>' +
            '    </li>' +
            '    {{/each}}' +
            '    <li class="dropdown-separate"></li>' +
            '{{/if}}' +
            '{{#each items}}' +
            '    {{#if this}}' +
            '        <li class="{{#if hasChild}}hasChild{{/if}}{{#if disabled}} dropdown-item-disabled{{/if}}" data-id="{{id}}" data-val="{{#if val}}{{val}}{{else}}{{text}}{{/if}}" data-level="{{#if level}}{{level}}{{else}}{{@root.level}}{{/if}}">' +
            '            <div title="{{text}}">{{{text}}}</div>' +
            '            <div title="{{description}}">{{{description}}}</div>' +
            '        </li>' +
            '    {{else}}' +
            '        <li class="dropdown-separate"></li>' +
            '    {{/if}}' +
            '{{/each}}' +
            '{{#if (? items.length "===" 0)}}' +
            '    <li class="dropdown-item-placeholder">无可用选项</li>' +
            '{{/if}}' +
            '</ul>'
        ),
        multiLevelDropdownLoading: utils.template(
            '<ul class="dropdown-level dropdown-root">' +
            '    <li class="dropdown-item">' +
            '        <div class="dropdown-loader">' +
            '            <div></div>' +
            '            <div></div>' +
            '            <div></div>' +
            '        </div>' +
            '    </li>' +
            '</ul>'
        ),
    };

    /**
     * 页面空间
     */
    window.app = {};

    /**
     * 页面初始化完成事件
     */
    window.init = new Promise(function (resolve) {
        $(document).on("frame.loaded", function () {
            resolve(bridge);
        });
    });

    /**
     * 缓存空间
     * @param methods 额外操作
     * @returns {cacheSpace|{}}
     */
    window.cache = function (methods) {
        if (methods === undefined)
            return _.cacheSpace;

        switch (methods) {
            case "serialize"://JSON序列化
                return JSON.stringify(_.cacheSpace || {});
            case "deserialize"://JSON反序列化 传入非法字符串或为空时将清空缓存空间
                try {
                    _.cacheSpace = JSON.parse(arguments[1] || "{}");
                } catch (e) {
                    _.cacheSpace = {};
                }
                break;
            case "clear":
                _.cacheSpace = {};
                break;
        }
    };

    /**
     * 公共类
     */
    window.common = {
        /**
         * 转换十进制为列编号
         * @param value 十进制数字
         * @return String
         */
        dec2Base26: function (value) {
            var absValue = Math.abs(value);

            var text = "";
            while (absValue > 0) {
                var remain = absValue % 26 || 26;
                text = String.fromCharCode(64 + remain) + text;

                absValue = (absValue - remain) / 26;
            }
            return text;
        },

        /**
         * 数字转换大写数字
         * @param n 数字
         * @return String
         */
        digitUppercase: (function () {
            var fraction = ['角', '分'];
            var digit = [
                '零', '壹', '贰', '叁', '肆',
                '伍', '陆', '柒', '捌', '玖'
            ];
            var unit = [
                ['元', '万', '亿', "兆", "京"],
                ['', '拾', '佰', '仟']
            ];

            // 向右移位
            function shiftRight(number, digit) {
                digit = parseInt(digit, 10);
                var value = number.toString().split('e');
                return +(value[0] + 'e' + (value[1] ? (+value[1] + digit) : digit))
            }

            // 向左移位
            function shiftLeft(number, digit) {
                digit = parseInt(digit, 10);
                var value = number.toString().split('e');
                return +(value[0] + 'e' + (value[1] ? (+value[1] - digit) : -digit))
            }

            return function (number) {
                var head = number < 0 ? '欠' : '';
                number = Math.abs(number);

                var fractionStr = '';
                for (var i = 0; i < fraction.length; i++) {
                    fractionStr += (digit[Math.floor(shiftRight(number, 1 + i)) % 10] + fraction[i]);
                }
                fractionStr = (
                    fractionStr
                        .replace(/(零.)*零分/, '')
                        .replace(/(零.)+/g, '零')
                ) || '整';
                number = Math.floor(number);

                var digitStr = '';
                for (var i = 0; i < unit[0].length && number > 0; i++) {
                    var pending = '';
                    for (var j = 0; j < unit[1].length && number > 0; j++) {
                        pending = digit[number % 10] + unit[1][j] + pending;
                        number = Math.floor(shiftLeft(number, 1));
                    }
                    digitStr = pending.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + digitStr;
                }
                digitStr = digitStr.replace(/(零.)*零元/, '元')
                    .replace(/(零.)+/g, '零')
                    .replace(/^整$/, '零元整');

                var output = digitStr + fractionStr;
                return head + (output === "整" ? "零元整" : output);
            };
        })(),

        /**
         * 基础权限鉴权
         * @param urls 基础权限路径
         * @param msg 权限不足时提示文本
         * @param closeTab 是否关闭当前标签页
         * @returns {Promise<T>}
         */
        basePermitsCheck: function (urls, msg, closeTab) {
            return new Promise(function (resolve) {
                if (window["bridge"]) {
                    resolve(window["bridge"]);
                    return;
                }
                init.then(resolve);
            }).then(function (bridge) {
                var results = _lodash
                    .chain(urls)
                    .flattenDeep()
                    .map(function (urlItem) {
                        var result = null;

                        if (urlItem.type)
                            result = bridge.permits[urlItem.type === "pages" ? "pages" : "test"](urlItem.url, urlItem.url[0] === "/" ? "/" : undefined, true);
                        result = bridge.permits.test(urlItem, urlItem[0] === "/" ? "/" : undefined, true);

                        if (result.status)
                            result._condition = urlItem;

                        return result;
                    })
                    .groupBy(function (result) {
                        if (result.status)
                            return result.status;
                        else if (result)
                            return bridge.permits.pluginStatus.VALID;
                        else
                            return bridge.permits.pluginStatus.INVALID;
                    })
                    .value();

                if ((results["invalid"] || []).length > 0) {
                    window.parent.layer.alert((msg || "您无此操作权限。"), {title: "提示", icon: 5});
                    if (closeTab)
                        bridge.tabs.close(bridge.id);
                }

                return new Promise(function (resolve) {
                    resolve(results);
                });
            })
        },

        /**
         * 格式化时间
         * @param time moment对象/级时间戳
         * @param isShort 短时间（不带时分秒部分）
         * @returns {string}
         */
        time: function (time, isShort) {
            return ((time instanceof moment) ? time : (time ? moment(time, "X") : moment())).format("YYYY-MM-DD" + (!isShort ? " HH:mm:ss" : ""));
        },

        /**
         * 计算时间差
         * @param timeA moment对象/秒级时间戳
         * @param timeB moment对象/秒级时间戳
         * @param format 输出格式
         */
        timeDiff: function (timeA, timeB, format) {
            var _A = (timeA instanceof moment) ? timeA : (timeA ? moment(timeA, "X") : moment());
            var _B = (timeB instanceof moment) ? timeB : (timeB ? moment(timeB, "X") : moment());
            return moment.duration(Math.abs(_A.diff(_B))).format(format ? format : "Y[年]M[个月]D[天]h[小时]m[分钟]s[秒]");
        },

        /**
         * 打开加载中遮罩层
         */
        showLoading: function () {
            ++_.loading.counter;

            if (_.loading.counter !== 1)
                return;

            if (_.loading.timer) {
                clearTimeout(_.loading.timer);
                _.loading.timer = undefined;
                return;
            }

            setTimeout(function () {
                _.loading.element.modal({
                    show: true,
                    keyboard: false,
                    backdrop: "static"
                });
            }, _.loading.element.hasClass("modal-in-progress") ? 100 : 0);
        },

        /**
         * 关闭加载中遮罩层（关闭次数需和打开次数一致）
         * @param immediately 立即关闭
         */
        hideLoading: function (immediately) {
            --_.loading.counter;

            if (_.loading.counter !== 0 && !immediately)
                return;

            if (immediately) {
                _.loading.counter = 0;
                _.loading.element.modal("hide");
                clearTimeout(_.loading.timer);
                _.loading.timer = null;
                return;
            }

            _.loading.timer = setTimeout(function () {
                _.loading.element.modal("hide");
                _.loading.timer = undefined;
            }, _.loading.timeout);
        },

        /**
         * 打开加载中遮罩层
         */
        showLoadingToast: function () {
            ++_.loadingToast.counter;

            if (_.loadingToast.counter !== 1)
                return;

            if (_.loadingToast.timer) {
                clearTimeout(_.loadingToast.timer);
                _.loadingToast.timer = undefined;
                return;
            }

            setTimeout(function () {
                _.loadingToast.element.modal({
                    show: true,
                    keyboard: false,
                    backdrop: false
                });
            }, _.loadingToast.element.hasClass("modal-in-progress") ? 100 : 0);
        },

        /**
         * 关闭加载中遮罩层（关闭次数需和打开次数一致）
         * @param immediately 立即关闭
         */
        hideLoadingToast: function (immediately) {
            --_.loadingToast.counter;

            if (_.loadingToast.counter !== 0 && !immediately)
                return;

            if (immediately) {
                _.loadingToast.counter = 0;
                _.loadingToast.element.modal("hide");
                clearTimeout(_.loadingToast.timer);
                _.loadingToast.timer = null;
                return;
            }

            _.loadingToast.timer = setTimeout(function () {
                _.loadingToast.element.modal("hide");
                _.loadingToast.timer = undefined;
            }, _.loadingToast.timeout);
        },

        /**
         * 打开等待中遮罩层
         * @param config layui.layer配置
         */
        showWaiting: function (config) {
            ++_.waiting.counter;

            if (_.waiting.counter !== 1)
                return;

            if (_.waiting.timer) {
                clearTimeout(_.loading.waiting);
                _.waiting.timer = undefined;
                return;
            }

            _.waiting.layerIndex = layer.open($.extend({
                    content: "正在获取远程数据...",
                    title: "请等待",
                    icon: 0,
                    btn: [],
                    move: false
                },
                config,
                {
                    closeBtn: false,
                    resize: false,
                    shadeClose: false
                }));
        },

        /**
         * 关闭等待中遮罩层（关闭次数需和打开次数一致）
         * @param immediately 立即关闭
         */
        hideWaiting: function (immediately) {
            --_.waiting.counter;

            if (_.waiting.counter !== 0 && !immediately)
                return;

            if (immediately) {
                _.waiting.counter = 0;
                layer.close(_.waiting.layerIndex);
                clearTimeout(_.waiting.timer);
                _.loading.timer = null;
                return;
            }

            _.waiting.timer = setTimeout(function () {
                layer.close(_.waiting.layerIndex);
                _.waiting.timer = undefined;
            }, _.waiting.timeout);
        },

        /**
         * 收集数据
         * @param element 需收集的元素/选择器
         * @param config 收集配置
         * @param skipConvert 跳过单一值处理
         */
        collect: function (element, config, skipConvert) {
            var selector = (element instanceof jQuery) ? element : $(element);
            var storage = {};

            var first = null;
            var cfg = $.extend(true, {}, _.collect.defaults, config);
            selector.each(function (index, item) {
                var tag = $(item);
                if (_.containerTypes.indexOf(item.tagName) > -1) {//容器类标签
                    $.extend(storage, common.collect(tag.find("input,select,textarea"), config, true));
                    return;
                }

                var name = tag.attr("name");
                var data = tag.data();

                if (!name || (data.ignore && !cfg.force))//无name属性或标签被忽略并未强制收集
                    return;

                if (!skipConvert && selector.length === 1 && _.containerTypes.indexOf(item.tagName) === -1)//单一值处理
                    first = name;

                var collectValue = undefined;
                switch (item.tagName) {
                    case "INPUT":
                        var inputType = (tag.attr("type") || "text").toLowerCase();
                        if (_.collect.ignoreInputTypes.indexOf(inputType) > -1)//忽略在忽略列表中的类型
                            return;

                        if (inputType === "radio" && !tag.prop("checked"))//radio特殊处理（非选中状态不录入值）
                            return;
                        if (inputType === "checkbox") {//checkbox特殊处理（转换值为0/1）
                            storage[name] = shortcut._collectValue(cfg.collect, tag, data, tag.prop("checked") ? 1 : 0);
                            return;
                        }

                        collectValue = shortcut._collectValue(cfg.collect, tag, data);
                        break;
                    case "SELECT":
                        if (tag.hasClass("select2-hidden-accessible")) {//select2特殊处理
                            var select2 = data.select2;
                            if (!select2)
                                return;

                            var results = $.map(select2.data(), function (value) {
                                return shortcut._collectValue(cfg.collect, $(value.element), $.extend(true, {}, value, {collectsubmit: data.collectsubmit}), value.id);
                            });
                            results = $.grep(results, function (value) {
                                return !!value
                            });

                            if (select2.options.get("multiple"))//多选则返回全部结果
                                collectValue = results;
                            else
                                collectValue = results[0];
                        } else {
                            var selectChecked = tag.find("option:checked");
                            if (selectChecked.length > 0)
                                collectValue = shortcut._collectValue(cfg.collect, selectChecked, $.extend(true, {}, selectChecked.data(), {collectsubmit: data.collectsubmit}));
                        }
                        break;
                    case "TEXTAREA":
                        collectValue = shortcut._collectValue(cfg.collect, tag, data);
                        break;
                }

                if (data.collectcombine) {
                    if (!storage[name] || !storage[name].push)
                        storage[name] = [];

                    storage[name].push(collectValue);
                } else
                    storage[name] = collectValue;
            });

            return first ? storage[first] : storage;
        },

        /**
         * 填充数据
         * @param element 需填充的元素/选择器
         * @param config 填充配置
         * @param collection 数据集
         */
        fill: function (element, config, collection) {
            if (config && collection === undefined) {//参数调位
                collection = config;
                config = undefined;
            }
            if (!collection)
                return;

            var selector = (element instanceof jQuery) ? element : $(element);
            var cfg = $.extend(true, {}, _.fill.defaults, config);
            var combineFilled = [];

            selector.each(function (index, item) {
                var tag = $(item);
                if (_.containerTypes.indexOf(item.tagName) > -1) {//容器类标签
                    common.fill(tag.find("input,select,textarea"), config, collection);
                    return;
                }

                var name = tag.attr("name");
                var data = tag.data();
                var value = undefined;
                if (!name || (data.ignore && !cfg.force))//无name属性或标签被忽略并未强制填充
                    return;
                if (collection[name] !== undefined)//检查存在性
                    value = collection[name];
                else if (!objectPath.has(collection, name)) {
                    //在无法直接取值的情况下针对中括号进行处理
                    if (!_.fill.matchRegex.test(name))//检查是否包含中括号属性
                        return;

                    name = name.replace(/\[/gi, ".").replace(/]/gi, "");//替换
                    if (!objectPath.has(collection, name))//再次检查存在性
                        return;

                    value = objectPath.get(collection, name);
                } else
                    return;

                var isObject = utils.isType(value, utils.types.object);
                var idVal = (isObject ? (value.id || value._id || JSON.stringify(value)) : value);//取值优先级 id > _id > JSON.stringify
                var strVal = (isObject ? (value.str || value.name || JSON.stringify(value)) : value);//取值优先级 str > name > JSON.stringify

                var transfer = undefined;
                if (cfg.handler) {
                    var result = cfg.handler(tag, name, value, collection);
                    if (result === null)
                        transfer = null;
                    else if (result !== undefined)
                        transfer = $.extend(transfer, result);
                }
                if (cfg.handler && transfer === null)
                    return;

                var combinedValue = transfer || value;
                if (data.collectcombine && utils.isType(combinedValue, utils.types.array)) {
                    if (combineFilled.indexOf(name) !== -1)
                        return;

                    if (item.tagName === "INPUT") {
                        var inputType = (tag.attr("type") || "text").toLowerCase();
                        if (_.fill.ignoreInputTypes.indexOf(inputType) > -1 || inputType === "radio")//忽略在忽略列表中的类型
                            return;
                        var inputs = selector.filter("input[name='" + name + "'][type='" + inputType + "']");
                        inputs.prop("checked", false);
                        $.each(combinedValue, function (valueIndex, valueItem) {
                            if (inputType === "checkbox") {
                                $.each(inputs, function (combineIndex, combineItem) {
                                    var _input = $(combineItem);
                                    var _data = _input.data();

                                    if (_data.collectsubmit ? fastDeepEqual(_data.submit, valueItem) : _input.val() === valueItem)
                                        _input.prop("checked", true);
                                });
                            } else
                                $(inputs[valueIndex]).val(valueItem);
                        });
                        combineFilled.push(name);
                        return;
                    } else if (item.tagName === "TEXTAREA") {
                        var textareas = selector.filter("textarea[name='" + name + "']");
                        $.each(combinedValue, function (valueIndex, valueItem) {
                            $(textareas[valueIndex]).val(valueItem);
                        });
                        return;
                    }

                    //FIXME:不支持select在combine情况下的恢复，代码较乱需要重新整理
                }

                var transferIsObject = utils.isType(transfer, utils.types.object);
                switch (item.tagName) {
                    case "INPUT":
                        var inputType = (tag.attr("type") || "text").toLowerCase();
                        if (_.fill.ignoreInputTypes.indexOf(inputType) > -1)//忽略在忽略列表中的类型
                            return;

                        if (inputType === "radio") {//radio特殊处理（针对值进行选中）
                            var radioValue = data.collectsubmit ? data.submit : tag.val();
                            var radioValueType = utils.getType(radioValue);
                            var radioValueIsObject = radioValueType === utils.types.object || radioValueType === utils.types.array;

                            // console.log({
                            //     name: name,
                            //     isObj: radioValueIsObject,
                            //     rv: radioValue,
                            //     left: JSON.stringify(radioValue),
                            //     right: JSON.stringify(transferIsObject ? transfer.val : (transfer || strVal))
                            // });
                            if (
                                // (radioValueIsObject && JSON.stringify(radioValue) === JSON.stringify(transferIsObject ? transfer.val : (transfer || strVal))) || //before 2019/01/16 has problem
                                (radioValueIsObject && fastDeepEqual(radioValue, (transferIsObject ? transfer.submit : (transfer || value)))) ||
                                (!radioValueIsObject && radioValue === (transferIsObject ? transfer.val : (transfer || strVal)).toString())
                            )
                                tag.prop("checked", true);

                            return;
                        }
                        if (inputType === "checkbox") {//checkbox特殊处理（转换值）
                            tag.prop("checked", !!(transfer || strVal));
                            return;
                        }

                        tag.data("submit", transferIsObject ? transfer.submit : (transfer || value));
                        tag.val(transferIsObject ? transfer.val : (transfer || strVal)).trigger("change");
                        break;
                    case "SELECT":
                        if (tag.hasClass("select2-hidden-accessible")) {//select2 特殊处理
                            if (value && value.push)
                                transfer = $.extend($.map(value, function (valueItem) {
                                    return {
                                        id: valueItem.id || valueItem._id || valueItem,
                                        text: valueItem.str || valueItem.name || valueItem,
                                        title: valueItem.str || valueItem.name || valueItem,
                                        submit: valueItem
                                    }
                                }), transfer);
                            else {
                                var _value = value || {};
                                transfer = $.extend({
                                    id: _value.id || _value._id || value,
                                    text: _value.str || _value.name || value,
                                    title: _value.str || _value.name || value,
                                    submit: value
                                }, transfer);
                            }

                            var select2 = data.select2;
                            if (!select2)
                                return;

                            var select = transfer || value;
                            if (select && select.push) {//数组
                                $.each(select, function (index, item) {
                                    if (item.id)
                                        select2.trigger("select", {
                                            data: $.extend({
                                                id: item,
                                                text: item,
                                                title: item,
                                                submit: item
                                            }, item)
                                        });
                                });
                            } else {
                                if (select.id)
                                    select2.trigger("select", {
                                        data: $.extend({
                                            id: select,
                                            text: select,
                                            title: select,
                                            submit: select
                                        }, select)
                                    });
                            }
                            return;
                        }

                        tag.find("option").each(function (index, item) {
                            var option = $(item);
                            var v = (transfer || idVal).toString();
                            if (option.val() === v || option.text() === v) {
                                tag.val(v).trigger("change");
                                return false;
                            }
                        });
                        break;
                    case "TEXTAREA":
                        tag.data("submit", transferIsObject ? transfer.submit : (transfer || value));
                        tag.val(transferIsObject ? transfer.val : (transfer || value)).trigger("change");
                        break;
                }
            });

            return this;
        },

        /**
         * 漂浮消息（zui）
         * toastMessage("foo","warning","refresh")
         * toastMessage({})
         *
         * @param content 内容
         * @param type 类型
         * @param icon 图标
         */
        toastMessage: function (content, type, icon) {
            var settings = {
                type: "info",
                placement: "top-right",
                icon: ""
            };

            if (utils.isType(content, utils.types.object)) {
                $.extend(settings, content);
            } else {
                settings.type = type;
                settings.message = content;
                settings.icon = icon;
            }

            new $.zui.Messager(settings).show();
        },

        /**
         * 漂浮错误（zui）
         * @param content 内容
         * @param icon 图标
         */
        toastError: function (content, icon) {
            new $.zui.Messager($.extend({
                type: "danger",
                placement: "top-right",
                icon: "exclamation-triangle",
            }, {
                message: content,
                icon: icon
            })).show();
        },

        /**
         * 加载中 漂浮消息（zui）
         * loadingToastMessage("foo")
         * loadingToastMessage({})
         *
         * @param content 内容
         */
        loadingToastMessage: function (content) {
            var options = {
                icon: "circle-notch fa-spin",
                type: "primary",
                message: "正在加载...",
                placement: "top-right",
                close: false,
                time: 0
            };

            if (utils.isType(content, utils.types.object))
                $.extend(options, content);
            else if (content)
                options.message = content;

            return new $.zui.Messager(options);
        },

        /**
         * 匹配两个对象的值是否相等且一致
         * @param left 对象A
         * @param right 对象B
         */
        isValueIdentical: function (left, right) {
            return fastDeepEqual(left, right);
        },

        /**
         * 通用处理
         */
        handlers: {
            /**
             * 请求失败时的通用处理（忽略abort）
             * @param options 漂浮消息（zui）的配置
             * @param message 自定义消息文本 function(error)/string
             */
            ajaxError: function (options, message) {
                var defaults = {
                    type: "danger",
                    placement: "top-right",
                    icon: "exclamation-triangle"
                };

                if (utils.isType(options, utils.types.string)) {
                    message = options;
                    options = null;
                }

                return function (request) {
                    if (request.statusText === "abort")
                        return;
                    if (request.readyState === 4 && request.status === 403) {
                        common.toastError("您无此操作权限。");
                        return;
                    }
                    common.toastMessage($.extend(defaults, options, {
                        message: utils.isType(message, utils.types.function) ? message(request) : (message || ("系统异常：" + request.statusText + " (" + request.status + ")"))
                    }));
                };
            },

            /**
             * 地区多级下拉菜单筛选处理
             * @param data 数据
             * @param keyword 关键字
             */
            areaFilter: function (data, keyword) {
                if (!keyword)
                    return data[0] || [];
                var lowerKeyword = keyword.toLowerCase();

                return $.map(data, function (level, levelIndex) {
                    return level.filter(function (item) {
                        return item.submit.mergename.toLowerCase().indexOf(lowerKeyword) > -1 ||
                            (item.submit.code && item.submit.code === keyword) ||
                            (item.submit.zip && item.submit.zip === keyword) ||
                            item.submit.pinyin.indexOf(lowerKeyword) > -1
                    }).map(function (item) {
                        return $.extend(true, {}, item, {
                            text: item.submit.mergename,
                            level: levelIndex
                        });
                    })
                });
            },

            /**
             * 多级下拉菜单查找指定选项
             * @param array 数据源
             * @param filter 筛选器（object/function(item)）
             */
            dropdownMatch: function (array, filter) {
                var filterIsFunc = utils.isType(filter, utils.types.function);

                var matched = $.map(array, function (level) {
                    var matches = $.grep(level, function (item) {
                        return filterIsFunc ? filter(item) : item.id == filter;
                    });

                    return matches.length > 0 ? matches[0] : null;
                });

                return matched.length > 0 ? matched[0] : null;
            },

            /**
             * 地区多级下拉菜单查找指定选项
             * @param filter 筛选器（object/function(item)）
             */
            areaMatch: function (filter) {
                return common.handlers.dropdownMatch(____JSONP("data.common.area"), filter);
            },
        },

        /**
         * 对话框操作
         */
        dialog: {
            /**
             * 检查是否有尚未保存的对话框
             */
            checkIsModifying: function () {
                var result = false;
                $.each(_.dialog.opened, function (key, element) {
                    var compare = _.dialog.compare[key] || {config: undefined, value: {}};
                    var collect = common.collect((compare.selector ? element.find(compare.selector) : element), compare.config, true);

                    if (!common.isValueIdentical(compare.value, collect)) {
                        result = true;
                        return false;
                    }
                });

                return result;
            },

            /**
             * 设置对话框初始值（不影响页面内容）
             *
             * setDefaultValue(dialogID,selector,config,value)
             * setDefaultValue(dialogID,selector,value)
             * setDefaultValue(dialogID,value)
             *
             * @param dialog 对话框ID选择器/对话框对象
             * @param selector 筛选选择器
             * @param config 收集数据用配置（common.collect）
             * @param value 对比值
             */
            setDefaultValue: function (dialog, selector, config, value) {
                if (selector && !config) {//参数调位
                    config = selector;
                    selector = undefined;
                }
                if (config && !value) {
                    value = config;
                    config = undefined;
                }

                var id = (dialog instanceof jQuery) ? ("#" + dialog.attr("id")) : dialog;
                if (!id || id === "#")
                    return;

                if (!value)//没有值时删除存储的对比值
                    delete _.dialog.compare[id];
                else
                    _.dialog.compare[id] = {
                        selector: selector,
                        config: config,
                        value: value
                    };
            },

            /**
             * 获取对话框初始值（不影响页面内容）
             * @param dialog 对话框ID选择器/对话框对象
             */
            getDefaultValue: function (dialog) {
                var id = (dialog instanceof jQuery) ? ("#" + dialog.attr("id")) : dialog;
                if (!id || id === "#")
                    return;
                return _.dialog.compare[id].value;
            },

            /**
             * 生成对话框对比值（不影响页面内容）
             *
             * generateDefaultValue(dialog,selector,config)
             * generateDefaultValue(dialog,selector)
             * generateDefaultValue(dialog)
             *
             * @param dialog 对话框ID选择器/对话框对象
             * @param selector 筛选选择器
             * @param config 收集数据用配置（common.collect）
             */
            generateDefaultValue: function (dialog, selector, config) {
                var obj = (dialog instanceof jQuery) ? dialog : $(dialog);
                var id = obj.attr("id");
                if (!id)
                    return;

                var value = null;
                if (selector)
                    value = obj.find(selector).collectForm(config, true);
                else
                    value = obj.collectForm(config, true);

                _.dialog.compare["#" + id] = {
                    selector: selector,
                    config: config,
                    value: value
                };
            }
        },

        /**
         * 类助手
         */
        classHelper: {
            config: (function () {
                var __super = function (relativeClass, method) {
                    if (!relativeClass)
                        return this.prototype;
                    return _lodash.get(relativeClass, "prototype.__methods." + method);
                };
                var __apply = function (instance) {
                    for (var key in this.__methods) {
                        if (!this.__methods[key])
                            return;
                        Object.defineProperty(instance, key, {
                            enumerable: false,
                            configurable: true,
                            value: this.__methods[key],
                        });
                    }

                    // Object.defineProperty(instance, "__constructor", {
                    //     enumerable: false,
                    //     configurable: true,
                    //     value: this
                    // });
                    return this;
                };

                return function (constructor, methods, extendTarget) {
                    constructor.__super = __super;
                    constructor.__methods = methods;
                    constructor.__apply = __apply;
                    if (extendTarget)
                        constructor.prototype = extendTarget;

                    return constructor;
                };
            })(),
        },
    };

    init.then(function () {
        var methods = {
            /**
             * 配置业务块方法
             * @param regionName 业务块
             * @param selector 业务块选择器
             * @param cfg 配置内容
             * @param type 列表类型
             */
            config: function (regionName, selector, cfg, type) {
                var region = _.region.space[regionName];
                if (!region)
                    return;

                //参数调整
                if (type === undefined)
                    type = "original";
                if (selector && !cfg) {
                    cfg = selector;
                    selector = undefined;
                }

                selector = selector || (type === "original" ? cfg.selector : null);
                if (!selector) {
                    bridge.warn((regionName ? (regionName + " ：") : "") + "无法正常执行 \'region.config\'，需要传入selector");
                    return;
                }
                selector = (selector instanceof jQuery) ? selector : $(selector);
                region.selector = selector;
                if (type === "original")
                    region.storage.selector = selector;
                region.selector.data("region", regionName);
                region.storage._type = type;

                switch (type) {
                    case "original":
                        region.storage.cfg = $.extend(true, {}, region.storage.cfg || _.region.defaults.original, cfg);
                        region.storage.page = 0;
                        methods.original._config(regionName, region);
                        break;
                    case "zuiDataGrid":
                        bridge.warn((regionName ? (regionName + " ：") : "") + "zuiDataGrid表格已过时，请使用常规表格的freeze功能。");
                        region.storage.cfg = $.extend(true, {}, region.storage.cfg || _.region.defaults.zuiDataGrid, cfg);
                        methods.zuiDataGrid._config(regionName, region);
                        break;
                }
            },

            original: {
                _config: function (regionName, region) {
                    var cfg = region.storage.cfg;

                    if (cfg.list && cfg.list.multiSelect) {//多选相关
                        if (cfg.list.multiSelect.enabled) {
                            region.storage._multiSelect = region.storage._multiSelect || [];//不存在则初始化 存在则不覆盖现有数据
                            region.selector.on("click", ".list-multiSelect input,.list-multiSelect", {
                                region: regionName
                            }, shortcut._multiSelectZuiSelectableSupportHandler);
                            region.selector.on("change", (cfg.list.multiSelect.freeze ? ".region-list.region-freeze-table " : "") + ".list-multiSelect input,.list-multiSelect-root input", {
                                region: regionName
                            }, shortcut._multiSelectHandler);
                        } else {
                            region.storage._multiSelect = [];
                            region.selector.off("click", shortcut._multiSelectZuiSelectableSupportHandler);//移除事件
                            region.selector.off("change", shortcut._multiSelectHandler);//移除事件
                        }
                    }

                    //排序相关
                    region.storage._sort = [];
                    region.selector.on("click", ".list-sortable", {
                        region: regionName
                    }, shortcut._sortHandler);

                    //高级筛选
                    region.selector.on("click", ".search-bar-expand", {
                        region: regionName
                    }, function (e) {
                        var self = $(e.currentTarget);
                        var searchbar = self.parents(".search-bar");

                        self.find(".icon").toggleClass("fa-rotate-180");
                        var _region = shortcut._getRegion(e.handleObj.data.region);
                        if (searchbar.length > 0)
                            searchbar.find(".search-bar-advanced").toggle().toggleClass("visible");
                        else if (_region.selector)
                            _region.selector.find(".search-bar-advanced").toggle().toggleClass("visible");
                    });

                    //冻结相关
                    if (cfg.list.freeze.enabled) {
                        (function () {
                            if (region.selector.find(".page-table .region-list-freeze").length)
                                return;

                            region.selector.find(".page-table-body").before("<div class='region-list-freeze'></div>");
                            region.selector.find(".page-table").on("mouseover", ".region-list tbody tr", function () {
                                var row = $(this);

                                var targetRows = region.selector.find(".region-list tbody").find("tr:eq(" + row.index() + ")");
                                targetRows.addClass(cfg.list.freeze.specificClassState.hover);

                                //同步单元格颜色
                                setTimeout(function () {
                                    var bgc = row.find("td:first").css("background-color");
                                    targetRows.find("td").css("background-color", bgc);
                                }, 0);

                                if (cfg.list.freeze.event.mouseOver)
                                    cfg.list.freeze.event.mouseOver.apply(this, arguments);
                            });
                            region.selector.find(".page-table").on("mouseout", ".region-list tbody tr", function () {
                                var row = $(this);

                                var targetRows = region.selector.find(".region-list tbody").find("tr:eq(" + row.index() + ")");
                                targetRows.removeClass(cfg.list.freeze.specificClassState.hover);

                                //同步单元格颜色
                                setTimeout(function () {
                                    targetRows.find("td").css("background-color", "");
                                }, 0);

                                if (cfg.list.freeze.event.mouseOut)
                                    cfg.list.freeze.event.mouseOut.apply(this, arguments);
                            });
                        })();
                    }

                    region.storage._isInitialized = true;
                    //define methods
                    region.list = function (page) {
                        return methods.original.list(regionName, page) || region;
                    };
                    region.refresh = function () {
                        return methods.original.refresh(regionName) || region;
                    };
                    region.reRender = function () {
                        return methods.original.reRender(regionName) || region;
                    };
                    region.getPage = function () {
                        return methods.original.getPage(regionName);
                    };
                    region.getSelected = function () {
                        return methods.original.getSelected(regionName);
                    };
                    region.setSelected = function (items) {
                        return methods.original.setSelected(regionName, items) || region;
                    };
                    region.restoreSelected = function () {
                        return methods.original.restoreSelected(regionName) || region;
                    };
                    region.clearSelected = function () {
                        return methods.original.clearSelected(regionName) || region;
                    };
                    region.zuiSelectableSupport = function (selector, config) {
                        return methods.original.zuiSelectableSupport(regionName, selector, config) || region;
                    };
                    region.initSort = methods.original.initSort;
                    region.getSort = function (getString) {
                        return methods.original.getSort(regionName, getString);
                    };
                    region.clearSort = function (refresh) {
                        return methods.original.clearSort(regionName, refresh) || region;
                    };
                },

                /**
                 * 加载列表
                 * @param regionName 业务块
                 * @param page 页码
                 */
                list: function (regionName, page) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st || !st.cfg.list || !st.cfg.list.request)
                        return;

                    if (st.cfg.list.request.url === undefined) {
                        bridge.warn(st.name + "：无法正常执行 \'list\'，配置了无效的url");
                        return shortcut.generateReject("common error");
                    }

                    if (!utils.isType(st.cfg.list.request.data, utils.types.function)) {
                        bridge.warn(st.name + "：无法正常执行 \'list\'，配置了无效的data");
                        return shortcut.generateReject("common error");
                    }

                    if (utils.lock.check(regionName + "_interfaces_list"))
                        return shortcut.generateReject("request in progress");
                    page = page || 1;
                    common.showLoading();
                    var promise = new Promise(function (resolve, reject, source) {
                        var ajaxConfigData = $.extend({_limit: 15}, st.cfg.list.request.data(page), {
                            _page: page,
                            _sort: methods.original.getSort(regionName, true)
                        });
                        var ajaxConfigEventProxy = {};
                        for (var cfgKey in st.cfg.list.request) {
                            if (cfgKey !== "data" && utils.isType(st.cfg.list.request[cfgKey], utils.types.function))
                                ajaxConfigEventProxy[cfgKey] = function () {
                                    st.cfg.list.request[cfgKey].apply(this, [].slice.apply(arguments).concat(ajaxConfigData));
                                };
                        }
                        var ajaxConfig = $.extend(true, {}, st.cfg.list.request, ajaxConfigEventProxy,
                            {
                                url: utils.isType(st.cfg.list.request.url, utils.types.function) ? st.cfg.list.request.url(page) : st.cfg.list.request.url,
                                data: $.extend(true, {}, ajaxConfigData)
                            }
                        );
                        var request = $.ajax(ajaxConfig).done(function (response) {
                            common.hideLoading();
                            utils.lock.release(regionName + "_interfaces_list");
                            if (response.code !== 1 || !response.msg.data) {
                                //TODO 分析错误类型并回调
                                if (st.cfg.list.error)
                                    st.cfg.list.error("", source, ajaxConfig);
                                reject({
                                    type: "",
                                    source: source,
                                    requestConfig: ajaxConfig
                                });
                                return;
                            }

                            var sequence = response.msg.data.length > 0 ? ((page - 1) * ajaxConfig.data._limit + 1) : 0;//序号
                            var renderInfo = {
                                page: page,
                                response: response,
                                params: ajaxConfigData,
                                sequence: sequence
                            };
                            st.latestListResponse = renderInfo;//存储最后一次列表请求

                            if (response.msg.data.length > 0) {//正常处理
                                st.page = page;

                                methods.original.reRender(regionName);
                                resolve(renderInfo);
                            } else if (response.msg.links > 0 && page > 1) {//空页回退最后有效的页码
                                methods.original.list(regionName, response.msg.links).then(resolve, reject);
                            } else {
                                var emptyTemplate = templates.listEmpty;//默认空数据模板
                                if (st.cfg.list.emptyTemplate && utils.isType(st.cfg.list.emptyTemplate, utils.types.function))//检测自定义模板
                                    emptyTemplate = st.cfg.list.emptyTemplate;

                                var table = st.selector.find(".region-list");
                                table.find("tbody").html(emptyTemplate({
                                    cols: ($.map(table.find("thead tr").children(), function (th) {
                                        var colspan = $(th).attr("colspan");
                                        return colspan ? parseInt(colspan) : 1;
                                    }) || []).reduce(function (value, current) {
                                        return value + current
                                    }, 0)
                                }));

                                methods.original.reRender(regionName, true);
                                resolve({
                                    page: page,
                                    response: {},
                                    params: ajaxConfigData,
                                    sequence: 0
                                });
                            }
                        }).fail(function (source) {
                            common.hideLoading();
                            utils.lock.release(regionName + "_interfaces_list");
                            if (st.cfg.list.error)
                                st.cfg.list.error("ajax error", source, ajaxConfig);
                            if (source.readyState === 4 && source.status === 403)
                                common.toastError("您无此操作权限。");

                            reject({
                                type: "ajax error",
                                source: source,
                                requestConfig: ajaxConfig
                            });
                        });

                        utils.lock.hold(regionName + "_interfaces_list", request);
                    });

                    promise.then(null, function (reason) {//uncaught
                    });

                    return promise;
                },

                /**
                 * 刷新当前页
                 * @param regionName 业务块
                 */
                refresh: function (regionName) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st)
                        return;

                    return methods.original.list(regionName, st.page || 1);
                },

                /**
                 * 重新渲染（渲染最后一次请求的结果）
                 * @param regionName 业务块
                 */
                reRender: function (regionName, componentsOnly) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st || !st.cfg.list || !st.cfg.list.request)
                        return;

                    if (!st.latestListResponse) {
                        bridge.warn(st.name + "：无法正常执行 \'reRender\'，需要至少执行过一次 \'list\'");
                        return shortcut.generateReject("common error");
                    }

                    var renderInfo = st.latestListResponse;
                    if (st.cfg.list.render && !componentsOnly)
                        st.cfg.list.render(renderInfo);

                    //region multiSelect
                    if (st.cfg.list.multiSelect && st.cfg.list.multiSelect.enabled) {
                        st.selector.find(".region-list .list-multiSelect-root input").prop("checked", false);//重置全选按钮

                        if (st.cfg.list.multiSelect.keep) {
                            if (!st.cfg.list.multiSelect.freeze)
                                methods.original.restoreSelected(regionName);
                        } else
                            methods.original.clearSelected(regionName);

                        var multiSelectTemplate = templates.listMultiSelectButton;//默认批量操作模板
                        if (st.cfg.list.multiSelect.template && utils.isType(st.cfg.list.multiSelect.template, utils.types.function))//检测自定义模板
                            multiSelectTemplate = st.cfg.list.multiSelect.template;

                        st.selector.find(".region-multi").html(multiSelectTemplate(st.cfg.list.multiSelect.templateData || {}));
                    }
                    //endregion

                    //region pagination
                    var paginationConfig = {
                        enabled: st.cfg.list.pagination ? st.cfg.list.pagination.enabled : true,
                        mini: st.cfg.list.pagination ? st.cfg.list.pagination.mini : false,
                        regionName: regionName,
                        info: {
                            page: st.page,//当前页码
                            links: renderInfo.response.msg.links || st.page,//总页数
                            markers: st.cfg.list.pagination ? (st.cfg.list.pagination.markers || 8) : 8,//最大显示页码数量
                            start: renderInfo.sequence,//序号开始
                            to: renderInfo.sequence > 0 ? (renderInfo.sequence + renderInfo.response.msg.data.length - 1) : 0,//序号结束
                            count: renderInfo.response.msg.count || (renderInfo.sequence > 0 ? (renderInfo.sequence + renderInfo.response.msg.data.length - 1) : 0)//总记录数
                        }
                    };
                    var paginationTemplate = templates.listPagination;//默认分页模板
                    if (st.cfg.list.pagination && st.cfg.list.pagination.template && utils.isType(st.cfg.list.pagination.template, utils.types.function))//检测自定义模板
                        paginationTemplate = st.cfg.list.pagination.template;

                    st.selector.find(".region-pagination").html(paginationTemplate(paginationConfig));
                    //endregion

                    //region freeze
                    if (st.cfg.list.freeze.enabled) {
                        setTimeout(function () {
                            var freezeContainer = st.selector.find(".region-list-freeze").html("");
                            var left = st.cfg.list.freeze.left;
                            var right = st.cfg.list.freeze.right;
                            if (!left.column && !right.column)//未配置有效冻结列
                                return;
                            var original = st.selector.find(".region-list");
                            var columns = _lodash.map(original.find("thead th"), function (item) {
                                var _item = $(item);
                                return {
                                    col: _lodash.toInteger(_item.attr("colspan") || 1),
                                    width: _item.outerWidth(),
                                    height: _item.outerHeight(),
                                    dom: _item
                                };
                            });
                            if (left.column + right.column >= columns.length)//配置冻结全部列
                                return;

                            var prepare = {
                                left: {
                                    cols: 0,
                                    width: 0,
                                    table: $("<table class='region-freeze-table region-freeze-table-left " + original.attr("class") + "'><thead><tr></tr></thead><tbody></tbody></table>")
                                },
                                right: {
                                    cols: 0,
                                    width: 0,
                                    table: $("<table class='region-freeze-table region-freeze-table-right " + original.attr("class") + "'><thead><tr></tr></thead><tbody></tbody></table>")
                                }
                            };
                            prepare.left.head = prepare.left.table.find("thead>tr");
                            prepare.left.body = prepare.left.table.find("tbody");
                            prepare.right.head = prepare.right.table.find("thead>tr");
                            prepare.right.body = prepare.right.table.find("tbody");

                            //列头处理
                            if (left.column)
                                _lodash
                                    .chain(columns)
                                    .take(left.column)
                                    .forEach(function (item) {
                                        prepare.left.cols += item.col;
                                        prepare.left.width += item.width;

                                        var clone = item.dom.clone();
                                        clone
                                            .css("width", item.width + "px")
                                            .css("height", item.height + "px")
                                            .addClass(left.className);
                                        prepare.left.head.append(clone);
                                    })
                                    .value();
                            if (right.column)
                                _lodash
                                    .chain(columns)
                                    .takeRight(right.column)
                                    .forEach(function (item) {
                                        prepare.right.cols += item.col;
                                        prepare.right.width += item.width;

                                        var clone = item.dom.clone();
                                        clone
                                            .css("width", item.width + "px")
                                            .css("height", item.height + "px")
                                            .addClass(right.className);
                                        prepare.right.head.append(clone);
                                    })
                                    .value();

                            //行处理
                            if ((renderInfo.response.msg.data || []).length > 0) { //跳过无数据情况
                                original.find("tbody>tr").each(function (rowIndex, rowItem) {
                                    var row = $(rowItem);
                                    var rowClass = row.attr("class");
                                    var children = row.children();

                                    var targetRow = {
                                        left: $("<tr></tr>"),
                                        right: $("<tr></tr>")
                                    };
                                    targetRow.left.attr("class", rowClass);
                                    targetRow.right.attr("class", rowClass);
                                    children.each(function (childIndex, childItem) {
                                        if (childIndex >= prepare.left.cols && childIndex < children.length - prepare.right.cols)
                                            return;

                                        var clone = $(childItem).clone();
                                        clone.css("height", $(childItem).outerHeight());
                                        clone.addClass(childIndex < prepare.left.cols ? left.className : right.className);
                                        targetRow[childIndex < prepare.left.cols ? "left" : "right"].append(clone);
                                    });

                                    prepare.left.table.append(targetRow.left);
                                    prepare.right.table.append(targetRow.right);
                                });
                            }

                            prepare.left.table.css("width", prepare.left.width + "px");
                            prepare.right.table.css("width", prepare.right.width + "px");
                            freezeContainer.append(prepare.left.table);
                            freezeContainer.append(prepare.right.table);

                            if (st.cfg.list.multiSelect.keep)
                                methods.original.restoreSelected(regionName);

                            if (st.cfg.list.freeze.event.render)
                                st.cfg.list.freeze.event.render.call(null, renderInfo);
                        });
                    }
                    //endregion

                    //TODO 生成其他组件
                    st.selector.checkPermits();
                },

                /**
                 * 获取页码
                 * @param regionName 业务块
                 */
                getPage: function (regionName) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st)
                        return;

                    return st.page;
                },

                /**
                 * 获取选中的元素
                 * @param regionName 业务块
                 * @returns {*}
                 */
                getSelected: function (regionName) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st || !st.cfg.list || !st.cfg.list.multiSelect)
                        return;

                    if (!st.cfg.list.multiSelect.enabled) {
                        bridge.warn(st.name + "：无法正常执行 \'getSelected\'，配置项 list.multiSelect.enabled 应为true");
                        return [];
                    }

                    return st._multiSelect || [];
                },

                /**
                 * 设置选中的元素
                 * @param regionName 业务块
                 * @param items 选中项数据
                 */
                setSelected: function (regionName, items) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st || !st.cfg.list || !st.cfg.list.multiSelect)
                        return;

                    if (!st.cfg.list.multiSelect.enabled) {
                        bridge.warn(st.name + "：无法正常执行 \'getSelected\'，配置项 list.multiSelect.enabled 应为true");
                        return [];
                    }

                    st._multiSelect = $.map(items, function (item) {
                        return $.extend(true, {}, {
                            id: item.id,
                            data: item.data
                        });
                    });
                },

                /**
                 * 还原选中的元素
                 * @param regionName 业务块
                 */
                restoreSelected: function (regionName) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st || !st.cfg.list || !st.cfg.list.multiSelect)
                        return;

                    if (!st.cfg.list.multiSelect.enabled) {
                        bridge.warn(st.name + "：无法正常执行 \'restoreSelected\'，配置项 list.multiSelect.enabled 应为true");
                        return [];
                    }

                    var scope = (st.cfg.list.multiSelect.freeze ? ".region-list.region-freeze-table" : ".region-list");
                    st.selector.find(scope + " .list-multiSelect-root input").prop("checked", false);//重置全选按钮
                    st.selector.find(scope + " .list-multiSelect input").each(function (elementIndex, element) {
                        var input = $(element);
                        var id = input.data("selectid");

                        $.each(st._multiSelect || [], function (index, item) {
                            if (item.id === id) {
                                input.prop("checked", true).trigger("change");
                                return false;
                            }
                        });
                    });
                },

                /**
                 * 清空选中的元素
                 * @param regionName 业务块
                 */
                clearSelected: function (regionName) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st || !st.cfg.list || !st.cfg.list.multiSelect)
                        return;

                    if (!st.cfg.list.multiSelect.enabled) {
                        bridge.warn(st.name + "：无法正常执行 \'clearSelected\'，配置项 list.multiSelect.enabled 应为true");
                        return;
                    }

                    st._multiSelect = [];
                    st.selector.find(".region-list tr").removeClass("selected");
                    st.selector.find(".list-multiSelect input,.list-multiSelect-root input").prop("checked", false);
                },

                /**
                 * 增加框选支持（将替代原始配置的clickBehavior、select和unselect字段）
                 * @param regionName 业务块
                 * @param selector 框选
                 * @param config zui selectable 配置
                 * @returns {*}
                 */
                zuiSelectableSupport: function (regionName, selector, config) {
                    var region = shortcut._getRegion(regionName);
                    var st = region.storage;
                    if (!st || !st.cfg.list || !st.cfg.list.multiSelect)
                        return;

                    bridge.warn(st.name + "：因客户使用习惯问题，已不建议使用。");
                    if (!st.cfg.list.multiSelect.enabled) {
                        bridge.warn(st.name + "：无法正常执行 \'zuiSelectableSupport\'，配置项 list.multiSelect.enabled 应为true");
                        return;
                    }

                    if (!selector) {
                        bridge.warn(st.name + "：无法正常执行 \'zuiSelectableSupport\'，需要传入 \'zui selectable\' 组件所绑定的元素");
                        return;
                    }

                    st._zuiSelectable = (selector instanceof jQuery) ? selector : $(selector);
                    return st._zuiSelectable.selectable($.extend(true,
                        {
                            mouseButton: "left",
                            selectClass: "selected"
                        },
                        config,
                        {
                            select: function (data) {
                                var row = st.selector.find("tbody tr[data-id='" + data.id + "']");
                                if (row.length > 0) {
                                    row.find(".list-multiSelect input").prop("checked", true).trigger("change");
                                }
                            },
                            unselect: function (data) {
                                var row = st.selector.find("tbody tr[data-id='" + data.id + "']");
                                if (row.length > 0) {
                                    row.find(".list-multiSelect input").prop("checked", false).trigger("change");
                                }
                            }
                        }
                    ));
                },

                /**
                 * 初始化排序按钮
                 * @param selector 包含可被初始化的元素/选择器
                 */
                initSort: function (selector) {
                    if (!selector) {
                        bridge.warn("CORE.SORT：无法正常执行 \'initSort\'，需要传入包含可被初始化的元素/选择器");
                        return;
                    }

                    ((selector instanceof jQuery) ? selector : $(selector)).find(".list-sortable").append("&nbsp;<i class='icon list-sortable-icon " + _.region.sort[0].css + "'></i>");
                },

                /**
                 * 获取排序状态
                 * @param regionName 业务块
                 * @param getString 获取成排序文本
                 */
                getSort: function (regionName, getString) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st)
                        return;

                    if (!getString)
                        return st._sort || [];

                    return (st._sort || []).map(function (item) {
                        return item.dataKey + " " + item.status
                    }).join(",");
                },

                /**
                 * 重置排序状态
                 * @param regionName 业务块
                 * @param refresh 刷新列表
                 */
                clearSort: function (regionName, refresh) {
                    var st = shortcut._getRegion(regionName).storage;
                    if (!st)
                        return;

                    st._sort = [];
                    st.selector.find(".list-sortable-icon").replaceWith("<i class='icon list-sortable-icon " + _.region.sort[0].css + "'></i>");
                    if (refresh)
                        methods.original.refresh(regionName);
                }
            },
            zuiDataGrid: {
                _config: function (regionName, region) {
                    var $grid = region.selector.find(".datagrid:first");
                    if ($grid.length <= 0)
                        return;

                    //define methods
                    region.list = function (page) {
                        return methods.zuiDataGrid.list(regionName, page) || region;
                    };
                    region.refresh = function () {
                        return methods.zuiDataGrid.refresh(regionName) || region;
                    };
                    region.reRender = function () {
                        return methods.zuiDataGrid.reRender(regionName) || region;
                    };
                    region.getPage = function () {
                        return methods.zuiDataGrid.getPage(regionName);
                    };
                    region.getSelected = function () {
                        return methods.zuiDataGrid.getSelected(regionName);
                    };
                    region.clearSelected = function () {
                        return methods.zuiDataGrid.clearSelected(regionName) || region;
                    };
                    region.getSort = function (getString) {
                        return methods.zuiDataGrid.getSort(regionName, getString);
                    };
                    region.clearSort = function (refresh) {
                        return methods.zuiDataGrid.clearSort(regionName, refresh) || region;
                    };

                    region.storage.gridLoadTimes = 0;
                    region.storage._isInitialized = true;

                    //多选fix（part.selectable）
                    region.storage._multiSelect = [];
                    region.storage.cfg.selectable.select = function (data) {
                        if (!region.grid)
                            return;

                        shortcut._multiSelectZuiDataGridStorageFix(region, region.grid.getRowConfig(data.id).data, true);
                        region.grid.checkRow(data.id, true);
                    };
                    region.storage.cfg.selectable.unselect = function (data) {
                        if (!region.grid)
                            return;

                        shortcut._multiSelectZuiDataGridStorageFix(region, region.grid.getRowConfig(data.id).data, false);
                        region.grid.checkRow(data.id, false);
                    };

                    //hack
                    var pagerDefaults = $.fn.pager.Constructor.DEFAULTS;//留存
                    $.fn.pager.Constructor.DEFAULTS = $.extend({}, $.fn.pager.Constructor.DEFAULTS, region.storage.cfg._pager);//替换Pager默认值
                    region.grid = $grid.datagrid(region.storage.cfg).data("zui.datagrid");
                    $.fn.pager.Constructor.DEFAULTS = pagerDefaults;//还原Pager默认值

                    //多选fix（part.event）
                    $grid.on("click", ".datagrid-cell-head.datagrid-has-checkbox", function (e) {
                        var state = $(e.currentTarget).find(".datagrid-checkbox").hasClass("checked");
                        $.map(region.grid.configsCache, function (item) {
                            if (item.rowId === "#header")
                                return;
                            shortcut._multiSelectZuiDataGridStorageFix(region, item.data, state);
                        });
                    });

                    //批量操作
                    $grid.on("onLoad", function (e, hasData) {
                        if (hasData) {
                            var multiSelectTemplate = templates.listMultiSelectButton;//默认批量操作模板
                            if (region.storage.cfg._multiSelect.template && utils.isType(region.storage.cfg._multiSelect.template, utils.types.function))//检测自定义模板
                                multiSelectTemplate = region.storage.cfg._multiSelect.template;

                            region.selector.find(".region-multi").html(multiSelectTemplate(region.storage.cfg._multiSelect.templateData || {}));
                            region.selector.checkPermits();
                        } else
                            common.toastError("您无此操作权限。");
                    });
                },

                /**
                 * 加载列表
                 * @param regionName 业务块
                 * @param page 页码
                 */
                list: function (regionName, page) {
                    var region = shortcut._getRegion(regionName);

                    region.grid.setSearch(++region.storage.gridLoadTimes);
                    region.grid.goToPage(page || 1);
                },

                /**
                 * 刷新当前页
                 * @param regionName 业务块
                 */
                refresh: function (regionName) {
                    var region = shortcut._getRegion(regionName);

                    region.list(region.getPage());
                },

                /**
                 * 重新渲染（渲染最后一次请求的结果）
                 * @param regionName 业务块
                 */
                reRender: function (regionName) {
                    var region = shortcut._getRegion(regionName);

                    region.grid.render();
                },

                /**
                 * 获取页码
                 * @param regionName 业务块
                 */
                getPage: function (regionName) {
                    var region = shortcut._getRegion(regionName);
                    if (!region.grid)
                        return 1;

                    return region.grid.pager.page;
                },

                /**
                 * 获取选中的元素
                 * @param regionName 业务块
                 * @returns {*}
                 */
                getSelected: function (regionName) {
                    var region = shortcut._getRegion(regionName);
                    if (!region.grid)
                        return [];

                    if (region.storage._multiSelect) {//使用修正方式获取已选中列表
                        return $.map(region.storage._multiSelect, function (item) {
                            return {
                                id: item.id,
                                data: item
                            };
                        });
                    }

                    return $.map(region.grid.states.selections, function (item, id) {//使用zui方式获取已选中列表
                        return {
                            id: id,
                            data: $.extend(item.data, {id: id})
                        };
                    });
                },

                /**
                 * 清空选中的元素
                 * @param regionName 业务块
                 */
                clearSelected: function (regionName) {
                    var region = shortcut._getRegion(regionName);

                    region.grid.states.selections = {};
                    region.reRender();
                },

                /**
                 * 获取排序状态
                 * @param regionName 业务块
                 * @param getString 获取成排序文本
                 */
                getSort: function (regionName, getString) {
                    var region = shortcut._getRegion(regionName);
                    if (!region.grid)
                        return getString ? "" : [];

                    var filterInfo = region.grid.getFilterParams();
                    if (!filterInfo.sortBy)
                        return getString ? "" : [];

                    var sortInfo = [{
                        dataKey: filterInfo.sortBy,
                        status: filterInfo.order
                    }];
                    return getString ? (sortInfo[0].dataKey + " " + sortInfo[0].status) : sortInfo;
                },

                /**
                 * 重置排序状态
                 * @param regionName 业务块
                 * @param refresh 刷新列表
                 */
                clearSort: function (regionName, refresh) {
                    var region = shortcut._getRegion(regionName);

                    region.grid.setSorter(null, "asc");
                    region.grid.render();
                    if (refresh)
                        region.list();
                }
            }
        };

        window.region = function (regionName) {
            if (_.region.space[regionName])
                return _.region.space[regionName];

            _.region.space[regionName] = {
                storage: {
                    name: regionName || "默认业务块",
                    cfg: null
                },
                selector: shortcut._emptyMethod,
                config: function (selector, cfg, type) {
                    return methods.config(regionName, selector, cfg, type);
                }
            };

            return _.region.space[regionName];
        };

        //region 公开默认值和预设值
        window.region.defaults = _.region.defaults;
        window.common.collect.defaults = _.collect.defaults;
        window.common.collect.auto = _.collect.collectTypes.auto;
        window.common.collect.submit = _.collect.collectTypes.submit;
        window.common.collect.val = _.collect.collectTypes.val;
        //endregion

        window.body = $(document.body);
        //region 多层级对话框
        var index = 1000;
        body.on("show.zui.modal", ".modal", function () {
            var self = $(this);
            var modalInstance = self.data("zui.modal");
            if (!_lodash.get(modalInstance, "options.backdrop"))
                return;

            index += 50;
            self.css("z-index", index);
            setTimeout(function () {
                $(".modal-backdrop:last").css("z-index", index - 1);
            });
        });
        //endregion

        //region 数据对话框
        body.on("show.zui.modal show.bs.modal", ".page-data-dialog", function () {
            var self = $(this);
            var id = self.attr("id");
            if (!id)
                return;

            _.dialog.opened["#" + id] = self;
        });
        body.on("hide.zui.modal", ".page-data-dialog", function () {
            var self = $(this);
            var id = self.attr("id");
            if (!id)
                return;

            delete _.dialog.opened["#" + id];
        });
        body.on("mousedown", ".page-data-dialog .modal-header", function () {
            _.fakeFocus.focus();
        });
        //endregion

        //region 对话框变化状态跟踪标记
        body.on("show.zui.modal shown.zui.modal hide.zui.modal hidden.zui.modal", function (e) {
            if (e.type === "show" || e.type === "hide")
                $(e.target).addClass("modal-in-progress");
            else if (e.type === "shown" || e.type === "hidden")
                $(e.target).removeClass("modal-in-progress");
        });
        //endregion

        //region 表单元素
        body.on("input change", "input", function () {
            var self = $(this);
            var controls = self.parents(".input-control").find(".input-control-auto");

            controls[self.val().length > 0 ? "show" : "hide"]();
        });
        body.on("click", ".input-control>.input-control-clear", function () {
            var input = $(this).parents(".input-control").find("input:first");
            if (input.attr("disabled"))
                return;
            input.val("").data("submit", null).trigger("change");
        });
        //endregion

        //region select2

        //select2傀儡（占位用）
        body.find("select.select2-dummy").filter(":not(.select2-hidden-accessible)").select2({
            language: "zh-CN",
            allowClear: true,
            minimumResultsForSearch: Infinity,
            data: []
        });

        //cascade初始化器
        body.find(".select2-cascade-init").each(function () {
            var self = $(this);
            self.select2CascadeInitialize(self.data("cascade"));
        });
        //endregion

        //region 快捷鉴权
        $(function () {
            $(document.body).checkPermits();
        });
        //endregion

        //region 表格下拉菜单兼容
        body.on("click", ".page-table-body .table-dropdown-container .dropdown-toggle", function (e) {
            var offset = {
                x: 15,
                y: 10
            };
            var dropdown = $(this).parent().find(".dropdown-menu");
            var width = dropdown.width();

            dropdown.css({
                "position": "fixed",
                "left": (offset.x + e.clientX - width) + "px",
                "top": (offset.y + e.clientY) + "px",
                "width": width + "px"
            });
        });
        //endregion
    });

    $.fn.extend({
        //region select2 cascade
        /**
         * select2 初始化级联控制
         * @param key 键
         * @param handler 构成数据预处理器
         */
        select2CascadeInitialize: function (key, handler) {
            this.data("__cascadeKey", key);
            this.on("change", {
                key: key,
                handler: handler
            }, shortcut._select2CascadeController);
            return this;
        },

        /**
         * select2 级联绑定
         * @param key 键
         * @param alias data别名
         * @param handler 预处理器
         */
        select2CascadeBinding: function (key, alias, handler) {
            if (utils.isType(alias, utils.types.function) && !handler) {//参数调位
                handler = alias;
                alias = undefined;
            }

            if (!_.select2Cascade[key])
                _.select2Cascade[key] = [];

            var item = {
                selector: this,
                alias: alias
            };
            if (handler)
                item.handler = handler;

            this.data("cascadeData", {});
            _.select2Cascade[key].push(item);

            return this;
        },

        /**
         * select2 取消级联关联
         */
        select2CascadeDestroy: function () {
            var key = this.data("__cascadeKey");
            if (key)
                delete _.select2Cascade[key];
            this.off("change", shortcut._select2CascadeController);

            return this;
        },

        //endregion

        //region select2
        /**
         * select2 值强制更新
         * @param destroyHandler 移除拦截器
         */
        select2ForceUpdate: function (destroyHandler) {
            if (!this.hasClass("select2-hidden-accessible") || (!destroyHandler && this.data("__selectForceUpdate")))
                return this;

            if (destroyHandler) {
                this.off("select2:selecting", shortcut._select2ForceUpdateHandler).data("__selectForceUpdate", null);
                return this;
            }
            this.on("select2:selecting", shortcut._select2ForceUpdateHandler).data("__selectForceUpdate", true);

            return this;
        },

        /**
         * 生成select2配置
         * @param configs select2配置
         * @param cascadeBind select2Cascade绑定 array[{key,alias,handler}]
         * @param cascadeAnnounce select2Cascade广播 string/object
         */
        select2Config: function (configs, cascadeBind, cascadeAnnounce) {
            if (!configs)
                return;

            //参数调位以及补正
            if (!utils.isType(cascadeBind, utils.types.array)) {
                cascadeAnnounce = cascadeBind;
                cascadeBind = [];
            }
            cascadeBind = cascadeBind || [];

            var action = function (dom) {
                //基本配置
                var select2Config = {
                    language: "zh-CN",
                    allowClear: true,
                    ajax: {
                        type: "post",
                        dataType: "json",
                        delay: 250
                    }
                };
                if (!configs.ajax)
                    delete select2Config.ajax;
                select2Config = $.extend(true, select2Config, configs);//merge

                //处理数据
                if (configs.ajax) {
                    var portStorage = {};
                    shortcut.port(portStorage, select2Config, "ajax.data", function (params) {
                        var userData = portStorage["ajax.data"];

                        var requestParams = {
                            name: params.term,
                            _limit: 15,
                            _page: params.page || 1
                        };

                        //处理级联绑定数据
                        if (cascadeBind.length > 0) {
                            var cascadeData = this.data("cascadeData");
                            _lodash.forEach(cascadeBind, function (item) {
                                requestParams[item.alias || item.key] = cascadeData[item.alias || item.key];
                            });
                        }

                        //处理自定义配置
                        if (utils.isType(userData, utils.types.function))
                            userData = userData.call(this, params, requestParams);
                        return $.extend(true, {}, requestParams, userData);
                    });
                    shortcut.port(portStorage, select2Config, "ajax.processResults", function (data, params) {
                        params.page = params.page || 1;

                        var prepare = {
                            pagination: {
                                more: (params.page * (params._limit || 15)) < data.msg.count
                            }
                        };

                        if (portStorage["ajax.processResults"])//处理自定义配置
                            prepare = portStorage["ajax.processResults"].call(this, data, params, prepare);
                        else//自动转换
                            prepare.results = _lodash.map(data.msg.data, function (item) {
                                if (item.area && item.area.str)
                                    item.title = "[" + item.area.str + "]" + (item.title || item.name);

                                return {
                                    id: item.id || item._id,
                                    text: item.name || item.title,
                                    title: item.title || item.name,
                                    submit: {
                                        id: item.id || item._id,
                                        str: item.name || item.title
                                    }
                                }
                            });

                        return prepare;
                    });
                }

                //配置并绑定
                dom.select2(select2Config);
                if (cascadeAnnounce) {
                    if (cascadeAnnounce.key)
                        dom.select2CascadeInitialize(cascadeAnnounce.key, cascadeAnnounce.handler);
                    else
                        dom.select2CascadeInitialize(cascadeAnnounce.toString());
                }
                if (cascadeBind.length > 0)
                    _lodash.forEach(cascadeBind, function (item) {
                        var args = [item.key, item.handler];
                        if (item.alias)
                            args.splice(1, 0, item.alias);
                        dom.select2CascadeBinding(args[0], args[1], args[2]);
                    });
            };

            //处理同时选中的多个元素
            _lodash.forEach(this, function (dom) {
                action($(dom));
            });

            return this;
        },

        //endregion

        //region 表单
        /**
         * 重置表单
         */
        clearForm: function () {
            this.find("input,textarea,select").each(function (index, item) {
                var element = $(item);
                var tagName = element.prop("tagName");

                switch (tagName) {
                    case "INPUT":
                        var inputType = (element.attr("type") || "text").toLowerCase();
                        element.prop("checked", false).data("submit", null);
                        if (inputType !== "radio")
                            element.val("");
                        element.trigger("change");
                        break;
                    case "SELECT":
                    case "TEXTAREA":
                        element.val(null).data("submit", null).trigger("change");
                        break;
                }
            });

            return this;
        },

        /**
         * 收集表单数据
         */
        collectForm: function (config, skipConvert) {
            return common.collect(this, config, skipConvert);
        },

        //endregion

        //region multiLevelDropdown
        /**
         * 多级下拉菜单
         * @param config 配置
         */
        multiLevelDropdown: function (config) {
            if (this.length <= 0) {
                return;
            }

            this.each(function (index, item) {
                var self = $(item);
                var id = self.data("__multiLevel_id");

                if (!id) {
                    if ((!utils.isType(config.levels, utils.types.array) || config.levels.length <= 0) && !config.remote)
                        return;
                    id = ++_.multiLevelDropdown.id;
                    self.data("__multiLevel_id", id);

                    self.on("focus", {id: id}, shortcut._multiLevelDropdownInitHandler);
                    self.on("blur", {id: id}, shortcut._multiLevelDropdownBlurHandler);
                    self.on("input", {id: id}, shortcut._multiLevelDropdownInitHandler);
                }

                _.multiLevelDropdown.storage[id] = $.extend((_.multiLevelDropdown.storage[id] || {}), {
                    source: self,
                    levels: config.levels,
                    search: config.search,
                    offset: config.offset,
                    customClass: config.customClass,
                    history: $.extend({maximum: 0, storage: "_module.multiLevelDropdown.name." + self.attr("name")}, config.history),
                    remote: config.remote,
                    temp: {},
                });
                shortcut._multiLevelDropdownReposition($("#dropdown-multi-container-" + id), self, _.multiLevelDropdown.storage[id].offset);
            });
            return this;
        },

        /**
         * 多级下拉菜单销毁
         */
        multiLevelDropdownDestroy: function () {
            this.each(function (index, item) {
                var self = $(item);
                var id = self.data("__multiLevel_id");
                if (!id)
                    return;

                self.data("__multiLevel_id", undefined).trigger("blur");
                delete _.multiLevelDropdown.storage[id];
                setTimeout(function () {
                    self.off("focus", shortcut._multiLevelDropdownInitHandler);
                    self.off("blur", shortcut._multiLevelDropdownBlurHandler);
                    self.off("input", shortcut._multiLevelDropdownInitHandler);
                }, 0);
            });
            return this;
        },

        /**
         * 多级下拉菜单获取历史
         */
        multiLevelDropdownHistory: function () {
            var id = this.data("__multiLevel_id");
            if (!id)
                return;
            var storage = _.multiLevelDropdown.storage[id];
            if (!storage || !storage.levels || storage.levels.length === 0)
                return;

            var histories = [];
            if (storage.history.maximum > 0) {
                var local = $.zui.store.get(storage.history.storage) || [];

                local.forEach(function (history) {
                    $.each(storage.levels, function (levelIndex, level) {
                        var found = false;
                        $.each(level, function (index, item) {
                            if (item.id === history.id) {
                                histories.push($.extend(true, {}, item, {level: levelIndex}));
                                found = true;
                                return false;
                            }
                        });

                        if (found)
                            return false;
                    });
                });
            }

            return histories;
        },

        //endregion

        /**
         * 重置select（清空所有选项）
         * @param doNotTrigger 不触发change事件
         * @param isSelect2Multiple 是否当作select2多选处理
         */
        resetSelect: function (doNotTrigger, isSelect2Multiple) {
            this.empty();

            //针对select2 清空伪装元素
            var select2 = this.data("select2");
            if (select2) {
                select2.$dropdown.find("li").remove();

                if (!select2.options.options.multiple && !isSelect2Multiple)
                    this.append("<option></option>");
            }

            if (doNotTrigger)
                return this;
            return this.trigger("change");
        },

        /**
         * 触发layui事件
         * @param module layui模块名
         * @param filter layui过滤器名
         * @param data 数据（function/object）
         */
        layuiTriggerEvent: function (module, filter, data) {
            if (!window.layui || this.length <= 0)
                return;

            window.layui.event.call(this[0], module, filter, (utils.isType(data, utils.types.function) ? data(this) : (data || {elem: this[0], value: this.val()})));
            return this;
        },

        /**
         * 预准备表单模态框
         * @param title 标题
         * @param defaults 初始值
         * @param config fill用config
         */
        prepareModal: function (title, defaults, config) {
            this.clearForm();
            this.find(".modal-title").html(title);
            common.fill(this, config || {}, defaults || {});
            common.dialog.setDefaultValue(this, common.collect(this));
            layui.form.render();

            return this;
        },

        /**
         * 检查权限
         */
        checkPermits: function () {
            var items = _lodash.map(this.find(".require-permits"), function (item) {
                return $(item);
            });

            if (this.hasClass("require-permits"))
                items.push(this);

            items.forEach(function (item) {
                var urls = item.data("permitsurl");
                var css = item.data("permitsfail");

                if (_lodash.every(urls.split(","), function (url) {
                    return bridge.permits.test(url, url[0] === "/" ? "/" : undefined, true);
                })) {
                    item.removeClass("require-permits");
                    return;
                }

                item.addClass(css);
            });
        }
    });

    $(function () {
        _.ready = true;
        layui.form.render();
    });

    //region 主题跟随框架
    if (theme) {
        var setTheme = function (themeName, content) {
            if (!themeName)
                return;

            var current = $("#theme");
            if (current.length > 0 && current.data("theme") === themeName)
                return;

            var tag = null;
            if (content)
                tag = theme.template_swap({
                    theme: themeName,
                    content: content
                });
            else
                tag = theme.template_set({
                    path: theme.themePath,
                    theme: themeName
                });

            if (current.length > 0)
                current.replaceWith(tag);
            else if (_.ready)
                $(document.body).append(tag);
            else
                document.writeln(tag);
        };
        $(document).on("frame.theme", function (e, data) {
            setTheme(data.theme, data.content);
        });
        setTheme(theme.getCurrentTheme() || "default");
    }
    //endregion

    //region 屏蔽浏览器自动完成
    var antiAutoCompleteDOMPrefix = "antiAutoComplete_" + +new Date();
    var antiAutoCompleteIndex = 0;
    $(window).on("DOMNodeInserted", _lodash.debounce(function () {
        $("input").filter(":not([id|='antiAutoComplete_'])").each(function (index, item) {
            var _item = $(item);
            if (_item.attr("id") === undefined)
                _item.attr("id", antiAutoCompleteDOMPrefix + ++antiAutoCompleteIndex);
            if (_item.attr("autocomplete") === undefined)
                _item.attr("autocomplete", "off");
            if (_item.attr("disableautocomplete") === undefined)
                _item.attr("disableautocomplete", "disableautocomplete");
        })
    }, 250, {leading: true, trailing: false}));
    //endregion

    //region 框架刷新要求响应
    $(document).on("frame.refresh", function (e, data) {
        location.reload();
    });
    //endregion

    //region fileHelper
    (function () {
        var proto = window.fileHelperProto || window.parent.fileHelperProto;
        if (!proto)
            return;

        var _ = _lodash;
        var fileHelper = new proto();
        var body = $(document.body);

        var convertExtensionToMimeOrRawOutput = function (source) {
            return source.startsWith("@") ? fileHelper.extension[source] : source;
        };
        fileHelper.select = (function () {
            var latestReject;
            var entry = function (config) {
                var cfg = $.extend(true, entry.defaultConfig, config);
                if (_.isArray(config.accept))
                    cfg.accept = _.map(config.accept, convertExtensionToMimeOrRawOutput).join(",");

                if (latestReject)
                    latestReject();

                var input = $(cfg.template.dom(cfg));
                body.append(input);

                var extensionValidate = function (accept, files) {
                    var hasAny = false;
                    accept = accept.split(",");
                    var inputs = _.reduce(accept, function (storage, item) {
                        if (item === "@any" || item === "*/*") {
                            hasAny = true;
                            return storage;
                        }
                        (item.indexOf("/") > -1 ? storage.mime : storage.extension).push(item);
                        return storage;
                    }, {mime: [], extension: []});

                    var validExtensions = [];
                    if (!hasAny || accept.length > 1) {
                        inputs.extension = _.map(inputs.extension, function (item) {
                            return item.startsWith(".") ? item.substring(1) : item;
                        });

                        validExtensions = _
                            .chain(inputs.extension)
                            .concat(fileHelper.mime2Extension(inputs.mime))
                            .uniq()
                            .value();
                    }

                    if (!validExtensions.length)//as any
                        return;

                    return _.findIndex(files, function (file) {
                        return !_.includes(validExtensions, file.extension.toLowerCase());
                    }) > -1;
                };
                var promise = new Promise(function (resolve, reject) {
                    latestReject = reject;

                    input.one("change", function () {
                        var files = fileHelper.parseFiles(_.toArray(input[0].files));
                        input.remove();

                        if (cfg.extensionValidate && extensionValidate(cfg.accept, files)) {
                            reject(cfg.template.wrongExtension());
                            return;
                        }

                        resolve(files);
                    });
                    input.click();
                });
                var clear = function () {
                    input.remove();
                };

                promise.then(clear, clear);
                return promise;
            };

            entry.template = {
                dom: utils.template(
                    '<input type="file" style="display: none;" accept="{{accept}}"{{#if multiple}} multiple{{/if}}{{#if capture}} capture="{{capture}}"{{/if}}>'
                ),
                wrongExtension: utils.template(
                    '文件类型不正确。'
                ),
            };
            entry.defaultConfig = {
                accept: "*/*",
                multiple: false,
                capture: false,
                extensionValidate: false,
                template: entry.template,
            };

            return entry
        })();
        fileHelper.upload = (function () {
            var prepare = function (storage) {
                var cfg = storage.cfg;
                var files = storage.files;

                return new Promise(function (resolve, reject) {
                    var totalSize = 0;

                    if (cfg.valid.totalCount > 0 && files.length > cfg.valid.totalCount) {
                        reject(cfg.template.overTotalCount(files));
                        return;
                    }

                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];

                        if (cfg.valid.maxSize && _.round(file.size) > cfg.valid.maxSize) {
                            reject(cfg.template.overSize(file));
                            return;
                        }

                        totalSize += file.size;
                    }

                    if (cfg.valid.totalSize && _.round(totalSize) > cfg.valid.totalSize) {
                        reject(cfg.template.overTotalSize(files));
                        return;
                    }

                    if (cfg.valid.custom) {
                        var customValidResult = cfg.valid.custom(files);
                        if (customValidResult !== undefined) {
                            reject(customValidResult);
                            return;
                        }
                    }

                    resolve(storage);
                });
            };
            var uploadStyle = {
                fileUpload: function (storage) {
                    var cfg = storage.cfg;
                    var formData = new FormData();

                    if (cfg.select.multiple)
                        (formData.set || formData.append).bind(formData)("multiple", "1");
                    var key = cfg.remote.key + (cfg.select.multiple ? "[]" : "");
                    _.forEach(storage.files, function (fileItem) {
                        formData.append(key, fileItem.raw);
                    });

                    if (cfg.remote.data)
                        formData = cfg.remote.data(formData, storage.files);

                    return {
                        url: cfg.remote.url,
                        type: cfg.remote.type,
                        data: formData,
                        dataType: cfg.remote.dataType,
                    };
                },
                default: function (storage) {
                    var cfg = storage.cfg;
                    var formData = new FormData();

                    var key = cfg.remote.key + "[]";
                    _.forEach(storage.files, function (fileItem) {
                        formData.append(key, fileItem.raw);
                    });

                    if (cfg.remote.data)
                        formData = cfg.remote.data(formData, storage.files);

                    return {
                        url: cfg.remote.url,
                        type: cfg.remote.type,
                        data: formData,
                        dataType: cfg.remote.dataType,
                    };
                }
            };
            var upload = function (storage) {
                var cfg = storage.cfg;
                var files = storage.files;

                return new Promise(function (resolve, reject) {
                    if (!cfg.remote.url) {
                        resolve(storage);
                        return;
                    }

                    var requestConfig = uploadStyle[cfg.remote.style || "default"](storage);
                    if (cfg.remote.loading) {
                        window.common && window.common.showLoadingToast && window.common.showLoadingToast();
                        window.app && window.app.preloader && window.app.preloader.show && window.app.preloader.show();
                    }
                    $
                        .ajax($.extend(requestConfig, {
                            processData: false,
                            contentType: false,
                        }))
                        .always(function () {
                            if (cfg.remote.loading) {
                                window.common && window.common.hideLoadingToast && window.common.hideLoadingToast();
                                window.app && window.app.preloader && window.app.preloader.hide && window.app.preloader.hide();
                            }
                        })
                        .done(function (response) {
                            storage.response = response;
                            resolve(storage);
                        })
                        .fail(function (request) {
                            if (request.statusText === "abort") {
                                reject(cfg.template.requestAbort(files));
                                return;
                            }
                            if (request.readyState === 4 && request.status === 403) {
                                reject(cfg.template.requestUnauthorized(files));
                                return;
                            }

                            reject();
                        });
                });
            };
            var result = function (storage) {
                return new Promise(function (resolve, reject) {
                    resolve({
                        files: storage.files,
                        response: storage.response,
                    });
                });
            };
            var entry = function (config) {
                var cfg = $.extend(true, entry.defaultConfig, config);
                if (_.isArray(config.files))
                    cfg.files = config.files;

                return Promise
                    .resolve({
                        cfg: cfg
                    })
                    .then(function (storage) {
                        return new Promise(function (resolve, reject) {
                            if (_.isArray(cfg.files) && cfg.files.length) {
                                storage.files = fileHelper.parseFiles(cfg.files);
                                resolve(storage);
                            }

                            fileHelper.select(config.select).then(function (files) {
                                storage.files = files;
                                resolve(storage);
                            }).catch(reject);
                        })
                    })
                    .then(prepare)
                    .then(upload)
                    .then(result);
            };

            entry.template = {
                overTotalCount: utils.template(
                    '文件超出数量限制。'
                ),
                overSize: utils.template(
                    '文件过大，请选择小一点的文件。'
                ),
                overTotalSize: utils.template(
                    '文件总尺寸过大，请重新选择。'
                ),
                requestAbort: utils.template(
                    '上传已取消。'
                ),
                requestUnauthorized: utils.template(
                    '权限不足。'
                ),
            };
            entry.defaultConfig = {
                files: null,//预置文件列表（file api）

                select: {},//select args
                valid: {
                    totalCount: 0,//最大文件数量（0为无限）
                    maxSize: fileHelper.size.MB * 2,//最大文件大小
                    totalSize: 0,//最大总计大小（0为无限）
                    custom: null,//自定义校验，(files) => {}，返回非undefined则reject
                },
                remote: {
                    url: "",
                    type: "post",
                    data: null,
                    dataType: "json",

                    style: "fileUpload",
                    key: "file",
                    loading: true,
                },
                template: entry.template,
            };

            return entry;
        })();
        fileHelper.read = (function () {
            var processor = {};

            var entry = function (file) {
                file = fileHelper.parseFile(file);
                var targetProcessor = processor[file.extension];
                if (!targetProcessor)
                    return Promise.reject("[fileHelper.read] \"" + file.type + "\" processor not found.");

                return targetProcessor.apply(undefined, arguments);
            };

            entry.reg = function (types, fn) {
                fn = _.isFunction(fn) ? fn : processor[fn];
                if (!fn)
                    return;

                _.forEach(fileHelper.mime2Extension(types), function (mimeType) {
                    processor[mimeType] = fn;
                });
            };

            return entry;
        })();
        fileHelper.readAll = function (files) {
            var args = _.toArray(arguments).slice(1);

            return Promise.all(_.map(files, function (file) {
                return fileHelper.read.apply(undefined, [file].concat(args));
            }));
        };
        fileHelper.read.reg([fileHelper.extension.txt], function (file, config) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function (event) {
                    resolve(event.target.result);
                };

                reader.onerror = function () {
                    reject("[fileHelper.read.txt] fileReader can not read this file.");
                };
                reader.onabort = reader.onerror;

                reader.readAsText(file)
            })
        });

        window.fileHelper = fileHelper;
    })();
    //endregion

    //FIXME DEBUG USE
    window.debug = {
        _: _,
        shortcut: shortcut
    };
})();